import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.relay');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-relay',
template: templateSource || '',
    styles: [``],
})
export class PageKieraRelayComponent implements OnInit, OnDestroy {
    // List
    public list: any[] = [];
    public total: number = 0;
    public search: any = { text: "", page: 1, dump: 20 };
    public pageSizeOptions: number[] = [10, 20, 50];
    public selectedRelayIds: Set<string> = new Set();
    public bulkDeleting: boolean = false;

    // Wizard state
    public showWizard: boolean = false;
    public wizardStep: number = 0;
    public wizardMode: string = '';
    public relayName: string = '';
    public creating: boolean = false;
    public useDummy: boolean = false;
    public wizardLoadingStep: number = 0;
    public wizardStepError: string = '';
    public templateSelectedFile: File | null = null;
    public templateSelectedFileName: string = '';
    public templateUploading: boolean = false;
    public templateUploadMessage: string = '';
    public templateUploadError: string = '';
    public templateUploadResult: any = null;
    public templatePreview: any = null;
    public templateValidationExpanded: boolean = false;
    public selectedTemplateClusterAction: string = 'create';
    public selectedTemplateClusterKey: string = '';
    public templateDraftMessage: string = '';
    private wizardLoadToken: number = 0;

    // Step 1: Node Selection
    public activeNodeTab: string = 'group'; // 'group' | 'node'
    public groups: any[] = [];
    public selectedGroupIds: Set<number> = new Set();
    public excludedGroupIds: Set<number> = new Set();
    public allNodes: any[] = [];
    public filterGroupId: string = '';
    public nodeSearchText: string = '';
    public showNodeRangeFilter: boolean = false;
    public nodeRangeFilter: any = { idStart: '', idEnd: '', bmcStart: '', bmcEnd: '' };
    public appliedNodeRangeFilter: any = { idStart: '', idEnd: '', bmcStart: '', bmcEnd: '' };
    public nodeRangeActive: boolean = false;
    public nodePage: number = 1;
    public nodeDump: number = 20;
    public nodeTotal: number = 0;
    public nodePageSizeOptions: number[] = [20, 50];
    public nodeCache: any = {};
    private nodeSearchTimer: any = null;
    public selectedNodeIds: Set<number> = new Set();
    public excludedNodeIds: Set<number> = new Set();

    // Step 2: Relay Servers
    public candidateNodes: any[] = [];
    public candidateTotal: number = 0;
    public selectedServerIds: Set<number> = new Set();
    public relaySubnets: any[] = [];
    public templateRelayMappings: any[] = [];
    public templateRelayCandidates: any[] = [];
    public relayMappingCriteria: any[] = [];
    public relayCandidateSearchText: string = '';
    public relayCandidateStatusFilter: string = 'all';
    public relayCandidatePage: number = 1;
    public relayCandidateDump: number = 12;
    public relayMappingAutoRunning: boolean = false;

    // Step 3: Deploy Relay Servers
    public images: any[] = [];
    public selectedImageId: string = '';
    public deploymentStatus: any = {}; // serverId → { imageDeployed, ready }

    // Step 4: Assign Computing Nodes
    public relayServers: any[] = [];
    public computingNodes: any[] = [];
    public selectedRelayServerId: any = null;
    public assignments: any = {}; // serverId → nodeId[]

    // Step 5: Deploy Computing Nodes
    public deployStarted: boolean = false;
    public step5ImageId: string = '';
    public computeWindowGapSeconds: any = 3;
    public computeWindowSize: any = 50;
    public poweringOff: boolean = false;
    public poweringOn: boolean = false;
    public poweredOff: boolean = false;
    public deployCompleted: boolean = false;
    public deployStats: any = { total: 0, deployed: 0, in_progress: 0, failed: 0 };
    public nodeDeployStatus: any = {}; // nodeId → { status: 'pending'|'deploying'|'deployed'|'failed', message? }
    public createdRelayId: string = '';
    public preflightLoading: boolean = false;
    public preflightReport: any = null;
    public preflightSectionCollapsed: any = {};
    public allowKnownBlockerOverride: boolean = false;
    public orchestrationJobId: string = '';
    public orchestrationJob: any = null;
    public orchestrationLogVisible: boolean = false;
    public orchestrationLogLoading: boolean = false;
    public orchestrationLogTitle: string = '';
    public orchestrationLogFilename: string = '';
    public orchestrationLogContent: string = '';
    public orchestrationLogMessage: string = '';
    public orchestrationLogMeta: any = null;
    public orchestrationLogTab: string = 'script';
    public orchestrationIntegratedLogs: any[] = [];
    public orchestrationNodeLogs: any[] = [];
    public orchestrationSelectedNodeLog: any = null;
    public orchestrationFailureSummary: any = null;
    public orchestrationFailureActionMessage: string = '';
    public orchestrationRecoveryRunning: boolean = false;
    public orchestrationRerunRunning: boolean = false;
    public orchestrationStopRunning: boolean = false;
    public orchestrationControlRunning: boolean = false;
    private deployCheckInterval: any = null;
    private orchestrationLogInterval: any = null;
    private preflightRequestTimeoutMs: number = 45000;
    private langSub?: Subscription;
    private preflightReportRaw: any = null;
    private orchestrationJobRaw: any = null;
    private readonly defaultComputeWindowGapSeconds: number = 3;
    private readonly defaultComputeWindowSize: number = 50;
    private readonly maxComputeWindowGapSeconds: number = 600;
    private readonly maxComputeWindowSize: number = 1000;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public objectKeys(obj: any): string[] { return obj ? Object.keys(obj) : []; }

    public async ngOnInit() {
        await this.service.init();
        this.langSub = this.translate.onLangChange.subscribe(async () => {
            this.reapplyRelayLocalization();
            await this.service.render();
        });
        await this.load();
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.langSub) this.langSub.unsubscribe();
        if (this.deployCheckInterval) {
            clearInterval(this.deployCheckInterval);
            this.deployCheckInterval = null;
        }
        this.stopOrchestrationLogPoll();
        // Step 3 deploy pollers 정리
        if (this.deployServerPollers) {
            Object.values(this.deployServerPollers).forEach((id: any) => clearInterval(id));
            this.deployServerPollers = {};
        }
    }

    // ======== List ========
    public async load(page: number = 1) {
        this.search.page = page;
        const { code, data } = await wiz.call("search", this.search);
        if (code === 200) {
            this.list = data.rows || [];
            this.total = data.total || 0;
            this.selectedRelayIds = new Set();
        }
        await this.service.render();
    }

    public viewRelay(id: string) {
        this.service.href(`/kiera/relay/${id}`);
    }

    public async deleteRelay(id: string) {
        if (!confirm("Are you sure you want to delete this relay group?")) return;
        const { code } = await wiz.call("delete", { id });
        if (code === 200) {
            this.selectedRelayIds.delete(this.relayId(id));
            await this.load();
        }
    }

    private relayId(id: any): string {
        return String(id || '');
    }

    public get selectedRelayCount() {
        return this.selectedRelayIds.size;
    }

    public isRelaySelected(id: any): boolean {
        return this.selectedRelayIds.has(this.relayId(id));
    }

    public allVisibleRelaysSelected(): boolean {
        return this.list.length > 0 && this.list.every((item: any) => this.isRelaySelected(item.id));
    }

    public someVisibleRelaysSelected(): boolean {
        return this.list.some((item: any) => this.isRelaySelected(item.id));
    }

    public toggleAllRelays(event: any) {
        const checked = !!event?.target?.checked;
        for (const item of this.list) {
            const id = this.relayId(item.id);
            if (!id) continue;
            if (checked) this.selectedRelayIds.add(id);
            else this.selectedRelayIds.delete(id);
        }
        this.service.render();
    }

    public toggleRelaySelect(id: any, event?: any) {
        const relayId = this.relayId(id);
        if (!relayId) return;
        const checked = event?.target ? !!event.target.checked : !this.selectedRelayIds.has(relayId);
        if (checked) this.selectedRelayIds.add(relayId);
        else this.selectedRelayIds.delete(relayId);
        this.service.render();
    }

    public async deleteSelectedRelays() {
        const ids = Array.from(this.selectedRelayIds);
        if (this.bulkDeleting || ids.length === 0) return;
        if (!confirm(`Are you sure you want to delete ${ids.length} selected relay group(s)?`)) return;

        this.bulkDeleting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("bulk_delete", { ids: JSON.stringify(ids) });
            if (code === 200) {
                const deleted = Number(data?.deleted !== undefined ? data.deleted : ids.length);
                const nextTotal = Math.max(0, this.total - deleted);
                const nextPage = Math.min(this.search.page, Math.ceil(nextTotal / this.search.dump) || 1);
                this.selectedRelayIds = new Set();
                await this.load(nextPage);
                if (data?.errors?.length) alert('Some selected relay groups could not be deleted.');
            } else {
                alert(data?.message || 'Failed to delete selected relay groups');
            }
        } finally {
            this.bulkDeleting = false;
            await this.service.render();
        }
    }

    public getStatusBadge(status: string): string {
        const map: any = {
            'ready': 'bg-green-100 text-green-700',
            'relay-ready': 'bg-green-100 text-green-700',
            'deploying': 'bg-blue-100 text-blue-700',
            'error': 'bg-red-100 text-red-700',
        };
        return map[status] || 'bg-zinc-100 text-zinc-600';
    }

    public totalPages() {
        return Math.ceil(this.total / this.search.dump) || 1;
    }

    public pageRange() {
        const tp = this.totalPages();
        const cur = this.search.page;
        let s = Math.max(1, cur - 2), e = Math.min(tp, cur + 2);
        if (e - s < 4) { if (s === 1) e = Math.min(tp, s + 4); else s = Math.max(1, e - 4); }
        const p = []; for (let i = s; i <= e; i++) p.push(i); return p;
    }

    public async changePageSize() {
        this.search.page = 1;
        await this.load(1);
    }

    // ======== Wizard ========
    public async openWizard() {
        this.showWizard = true;
        this.wizardStep = 0;
        this.wizardMode = '';
        this.relayName = '';
        this.useDummy = false;
        this.templateSelectedFile = null;
        this.templateSelectedFileName = '';
        this.templateUploading = false;
        this.templateUploadMessage = '';
        this.templateUploadError = '';
        this.templateUploadResult = null;
        this.templatePreview = null;
        this.templateValidationExpanded = false;
        this.selectedTemplateClusterAction = 'create';
        this.selectedTemplateClusterKey = '';
        this.templateDraftMessage = '';
        this.activeNodeTab = 'group';
        this.selectedGroupIds = new Set();
        this.excludedGroupIds = new Set();
        this.selectedNodeIds = new Set();
        this.excludedNodeIds = new Set();
        this.selectedServerIds = new Set();
        this.candidateNodes = [];
        this.candidateTotal = 0;
        this.resetTemplateRelayMappingState();
        this.selectedImageId = '';
        this.deploymentStatus = {};
        this.selectedRelayServerId = null;
        this.assignments = {};
        this.creating = false;
        this.filterGroupId = '';
        this.nodeSearchText = '';
        this.showNodeRangeFilter = false;
        this.nodeRangeFilter = { idStart: '', idEnd: '', bmcStart: '', bmcEnd: '' };
        this.appliedNodeRangeFilter = { idStart: '', idEnd: '', bmcStart: '', bmcEnd: '' };
        this.nodeRangeActive = false;
        this.nodePage = 1;
        this.nodeTotal = 0;
        this.nodeCache = {};
        this.createdRelayId = '';
        this.computeWindowGapSeconds = this.defaultComputeWindowGapSeconds;
        this.computeWindowSize = this.defaultComputeWindowSize;
        this.preflightLoading = false;
        this.setPreflightReport(null);
        this.allowKnownBlockerOverride = false;
        this.orchestrationJobId = '';
        this.setOrchestrationJob(null);
        this.cancelWizardStepLoad();
        await this.service.render();
    }

    public chooseWizardMode(mode: string) {
        this.wizardMode = mode;
        this.wizardStepError = '';
        this.service.render();
    }

    public async onRelayTemplateFileSelected(event: any) {
        const files = event?.target?.files;
        this.wizardMode = 'template';
        this.templateUploadMessage = '';
        this.templateUploadError = '';
        this.templateUploadResult = null;
        this.templatePreview = null;
        this.templateValidationExpanded = false;
        this.selectedTemplateClusterKey = '';
        this.templateDraftMessage = '';
        if (files && files.length > 0) {
            this.templateSelectedFile = files[0];
            this.templateSelectedFileName = this.templateSelectedFile?.name || '';
            await this.uploadRelayTemplateFile(event?.target);
            return;
        } else {
            this.templateSelectedFile = null;
            this.templateSelectedFileName = '';
        }
        this.service.render();
    }

    public async uploadRelayTemplateFile(fileInput?: any): Promise<boolean> {
        if (this.templateUploading) return false;
        if (!this.templateSelectedFile) {
            this.templateUploadError = '템플릿 파일을 선택하세요.';
            await this.service.render();
            return false;
        }

        const selectedFile = this.templateSelectedFile;

        this.wizardMode = 'template';
        this.templateUploading = true;
        this.templateUploadMessage = '';
        this.templateUploadError = '';
        this.templateUploadResult = null;
        this.templatePreview = null;

        let code = 0;
        let data: any = null;
        try {
            const contentBase64 = await this.readTemplateFileAsBase64(selectedFile);
            const result = await wiz.call("template_upload", {
                filename: selectedFile.name || this.templateSelectedFileName || 'relay-template.xlsx',
                content_base64: contentBase64,
            });
            code = result?.code || 0;
            data = result?.data || result;
        } catch (error: any) {
            data = { message: error?.message || '템플릿 파일 업로드에 실패했습니다.' };
        }

        this.templateUploading = false;
        if (fileInput) fileInput.value = '';

        if (code !== 200) {
            this.templateUploadError = data?.message || '템플릿 파일 업로드에 실패했습니다.';
            await this.service.render();
            return false;
        }

        this.templateUploadResult = data?.template || data || {};
        this.setRelayTemplatePreview(data?.preview || this.templateUploadResult?.preview || null);
        this.templateSelectedFile = null;
        this.templateSelectedFileName = this.templateUploadResult?.original_name || this.templateSelectedFileName;
        this.templateUploadMessage = data?.message || '템플릿 파일 업로드가 완료되었습니다.';
        await this.service.render();
        return true;
    }

    private async readTemplateFileAsBase64(file: File): Promise<string> {
        const buffer = await file.arrayBuffer();
        const bytes = new Uint8Array(buffer);
        const chunkSize = 0x8000;
        let binary = '';
        for (let index = 0; index < bytes.length; index += chunkSize) {
            const chunk = bytes.subarray(index, index + chunkSize);
            binary += String.fromCharCode(...Array.from(chunk));
        }
        return btoa(binary);
    }

    public async startSelectedWizardMode() {
        if (this.wizardMode === 'manual') {
            await this.startManualWizard();
            return;
        }
        if (this.wizardMode === 'template') {
            await this.startTemplateWizard();
        }
    }

    public async startTemplateWizard() {
        this.wizardMode = 'template';
        this.templateUploadError = '';
        this.templateDraftMessage = '';
        if (!this.templatePreview) {
            const uploaded = await this.uploadRelayTemplateFile();
            if (!uploaded) return;
        }
        this.wizardStep = 1;
        await this.service.render();
    }

    private setRelayTemplatePreview(preview: any) {
        this.templatePreview = preview || null;
        const clusters = this.templatePreview?.clusters || [];
        this.selectedTemplateClusterKey = clusters[0]?.key || '';
        this.selectedTemplateClusterAction = 'continue';
    }

    public async reloadRelayTemplatePreview() {
        const relativePath = this.templateUploadResult?.relative_path || this.templatePreview?.template?.relative_path || '';
        if (!relativePath) {
            this.templateUploadError = '다시 볼 템플릿 파일 정보가 없습니다.';
            await this.service.render();
            return;
        }
        this.templateUploading = true;
        this.templateUploadError = '';
        this.templateUploadMessage = '';
        await this.service.render();
        const { code, data } = await wiz.call("template_preview", { relative_path: relativePath });
        this.templateUploading = false;
        if (code !== 200) {
            this.templateUploadError = data?.message || '템플릿 미리보기를 다시 불러오지 못했습니다.';
            await this.service.render();
            return;
        }
        this.templateUploadResult = data?.template || this.templateUploadResult;
        this.setRelayTemplatePreview(data?.preview || null);
        this.templateUploadMessage = '템플릿 미리보기를 갱신했습니다.';
        await this.service.render();
    }

    public selectTemplateClusterAction(action: string) {
        if (action === 'update' && !this.templatePreview?.cluster?.can_update) return;
        if (action === 'create' && !this.templatePreview?.cluster?.can_create) return;
        this.selectedTemplateClusterAction = action;
        this.templateDraftMessage = '';
        this.service.render();
    }

    public selectTemplateCluster(cluster: any) {
        this.selectedTemplateClusterKey = cluster?.key || '';
        this.service.render();
    }

    public toggleTemplateValidationDetails() {
        this.templateValidationExpanded = !this.templateValidationExpanded;
        this.service.render();
    }

    public async saveRelayTemplateDraft() {
        const draft = {
            template: this.templateUploadResult,
            preview: this.templatePreview,
            action: this.selectedTemplateClusterAction,
            clusterKey: this.selectedTemplateClusterKey,
            savedAt: new Date().toISOString(),
        };
        try {
            localStorage.setItem('kiera.relay.templateDraft', JSON.stringify(draft));
            this.templateDraftMessage = '임시 저장되었습니다.';
        } catch (e) {
            this.templateDraftMessage = '브라우저 저장소에 임시 저장하지 못했습니다.';
        }
        await this.service.render();
    }

    public async continueTemplateWizard() {
        if (!this.templatePreview) return;
        if (!this.canGoTemplateStep2) return;

        const matchedNodes = (this.templatePreview?.matched_nodes || []).map((node: any) => ({
            ...node,
            id: Number(node.id),
            is_dhcp_server: Number(node.is_dhcp_server || 0),
        })).filter((node: any) => node.id > 0);

        this.candidateNodes = matchedNodes;
        this.candidateTotal = this.templatePreview?.summary?.total_nodes || matchedNodes.length;
        this.initializeTemplateRelayMappings();
        if (this.templateRelayMappings.length === 0) {
            this.selectedServerIds = new Set(
                matchedNodes
                    .filter((node: any) => String(node.template_role || '').toLowerCase() === 'relay')
                    .map((node: any) => Number(node.id))
            );
            if (this.selectedServerIds.size === 0 && matchedNodes.length > 0) {
                this.selectedServerIds.add(Number(matchedNodes[0].id));
            }
        }
        this.cacheNodes(matchedNodes);
        await this.loadRelaySubnets();
        this.ensureDhcpAuthorityGroups();
        this.wizardStep = 2;
        await this.service.render();
    }

    public async startManualWizard() {
        this.wizardMode = 'manual';
        this.wizardStep = 1;
        this.activeNodeTab = 'group';
        this.selectedGroupIds = new Set();
        this.excludedGroupIds = new Set();
        this.selectedNodeIds = new Set();
        this.excludedNodeIds = new Set();
        this.filterGroupId = '';
        this.nodeSearchText = '';
        this.showNodeRangeFilter = false;
        this.nodeRangeFilter = { idStart: '', idEnd: '', bmcStart: '', bmcEnd: '' };
        this.appliedNodeRangeFilter = { idStart: '', idEnd: '', bmcStart: '', bmcEnd: '' };
        this.nodeRangeActive = false;
        this.nodePage = 1;
        this.nodeTotal = 0;
        this.nodeCache = {};
        this.groups = [];
        this.allNodes = [];
        this.candidateNodes = [];
        this.candidateTotal = 0;
        this.selectedServerIds = new Set();
        this.resetTemplateRelayMappingState();

        const token = this.beginWizardStepLoad(1);
        await this.service.render();

        try {
            const { code, data } = await wiz.call("groups");
            if (!this.isWizardLoadCurrent(token)) return;
            if (code === 200) this.groups = data || [];
            else this.wizardStepError = data?.message || 'Failed to load groups.';

            await this.loadNodes(1, false, token);
        } catch (e) {
            if (this.isWizardLoadCurrent(token)) {
                this.wizardStepError = `Failed to initialize wizard: ${String(e)}`;
            }
        } finally {
            if (this.isWizardLoadCurrent(token)) {
                this.finishWizardStepLoad(token);
                await this.service.render();
            }
        }
    }

    public closeWizard() {
        this.cancelWizardStepLoad();
        this.createdRelayId = '';
        this.preflightLoading = false;
        this.setPreflightReport(null);
        this.allowKnownBlockerOverride = false;
        this.orchestrationJobId = '';
        this.setOrchestrationJob(null);
        this.showWizard = false;
        this.service.render();
    }

    public async loadNodes(page: number = 1, shouldRender: boolean = true, wizardToken?: number) {
        this.nodePage = page;
        const params: any = { page: this.nodePage, dump: this.nodeDump, text: this.nodeSearchText };
        if (this.filterGroupId) params.group_id = this.filterGroupId;
        this.appendNodeRangeParams(params);
        const { code, data } = await wiz.call("nodes", params);
        if (wizardToken !== undefined && !this.isWizardLoadCurrent(wizardToken)) return;
        if (code === 200) {
            this.allNodes = data.rows || [];
            this.nodeTotal = data.total || 0;
            this.cacheNodes(this.allNodes);
            this.wizardStepError = '';
        } else {
            this.wizardStepError = data?.message || 'Failed to load nodes.';
        }
        if (shouldRender) await this.service.render();
    }

    public async loadRelaySubnets() {
        const { code, data } = await wiz.call("relay_subnets");
        if (code === 200) {
            this.relaySubnets = (data?.rows || []).map((subnet: any) => this.normalizeRelaySubnetOption(subnet));
        }
    }

    private normalizeRelaySubnetOption(subnet: any): any {
        const originalKey = String(subnet?.key || '').trim();
        const subnetId = String(subnet?.id || '').trim();
        const name = String(subnet?.name || '').trim();
        const cidr = String(subnet?.cidr || '').trim();
        const vlanId = String(subnet?.vlan_id || '').trim();
        const key = subnetId ? `id:${subnetId}` : originalKey;
        const aliases = new Set<string>();
        for (const alias of [key, originalKey, subnetId, subnetId ? `id:${subnetId}` : '', name]) {
            const value = String(alias || '').trim();
            if (value) aliases.add(value);
        }
        if (cidr) aliases.add(`cidr:${cidr}`);
        if (vlanId && vlanId !== '0') aliases.add(`vlan:${vlanId}`);
        return {
            ...subnet,
            key,
            original_key: originalKey,
            aliases: Array.from(aliases),
        };
    }

    public async changeNodePageSize() {
        await this.loadNodes(1);
    }

    public scheduleNodeSearch() {
        if (this.nodeSearchTimer) clearTimeout(this.nodeSearchTimer);
        this.nodeSearchTimer = setTimeout(async () => {
            await this.loadNodes(1);
        }, 300);
    }

    public async toggleNodeRangeFilter() {
        this.showNodeRangeFilter = !this.showNodeRangeFilter;
        await this.service.render();
    }

    public get hasNodeRangeInput() {
        return this.hasNodeRangeValue(this.nodeRangeFilter);
    }

    public async applyNodeRangeFilter() {
        const next = this.normalizeNodeRangeFilter(this.nodeRangeFilter);
        this.nodeRangeFilter = { ...next };
        this.appliedNodeRangeFilter = { ...next };
        this.nodeRangeActive = this.hasNodeRangeValue(next);
        await this.loadNodes(1);
    }

    public async clearNodeRangeFilter() {
        const empty = { idStart: '', idEnd: '', bmcStart: '', bmcEnd: '' };
        this.nodeRangeFilter = { ...empty };
        this.appliedNodeRangeFilter = { ...empty };
        this.nodeRangeActive = false;
        await this.loadNodes(1);
    }

    private normalizeNodeRangeFilter(source: any) {
        return {
            idStart: String(source?.idStart || '').trim(),
            idEnd: String(source?.idEnd || '').trim(),
            bmcStart: String(source?.bmcStart || '').trim(),
            bmcEnd: String(source?.bmcEnd || '').trim(),
        };
    }

    private hasNodeRangeValue(source: any): boolean {
        const data = this.normalizeNodeRangeFilter(source);
        return !!(data.idStart || data.idEnd || data.bmcStart || data.bmcEnd);
    }

    private appendNodeRangeParams(params: any) {
        if (!this.nodeRangeActive) return;
        const data = this.normalizeNodeRangeFilter(this.appliedNodeRangeFilter);
        if (data.idStart) params.id_start = data.idStart;
        if (data.idEnd) params.id_end = data.idEnd;
        if (data.bmcStart) params.bmc_start = data.bmcStart;
        if (data.bmcEnd) params.bmc_end = data.bmcEnd;
    }

    private cacheNodes(rows: any[]) {
        for (const row of rows || []) {
            if (row && row.id != null) this.nodeCache[Number(row.id)] = row;
        }
    }

    public nodeTotalPages() {
        return Math.ceil(this.nodeTotal / this.nodeDump) || 1;
    }

    public nodePageList() {
        const tp = this.nodeTotalPages();
        const current = this.nodePage;
        const pages: number[] = [];
        const start = Math.max(1, current - 2);
        const end = Math.min(tp, current + 2);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    public get filteredNodes() {
        return this.allNodes;
    }

    // Step 1 helpers
    public isIncluded(id: number) { return this.selectedNodeIds.has(id); }
    public isExcluded(id: number) { return this.excludedNodeIds.has(id); }

    public toggleInclude(id: number) {
        if (this.selectedNodeIds.has(id)) this.selectedNodeIds.delete(id);
        else { this.selectedNodeIds.add(id); this.excludedNodeIds.delete(id); }
        this.service.render();
    }

    public toggleExclude(id: number) {
        if (this.excludedNodeIds.has(id)) this.excludedNodeIds.delete(id);
        else { this.excludedNodeIds.add(id); this.selectedNodeIds.delete(id); }
        this.service.render();
    }

    public selectAllVisible() {
        // Select only the rows returned by the current node query/page.
        this.filteredNodes.forEach(n => {
            if (!this.excludedNodeIds.has(n.id)) this.selectedNodeIds.add(n.id);
        });
        this.service.render();
    }

    public deselectAllVisible() {
        this.filteredNodes.forEach(n => this.selectedNodeIds.delete(n.id));
        this.service.render();
    }

    public get includedCount() { return this.selectedNodeIds.size; }
    public get excludedCount() { return this.excludedNodeIds.size; }

    // Step navigation
    // Step 1 summary helpers
    public get selectedGroupNames(): string[] {
        return this.groups.filter(g => this.selectedGroupIds.has(g.id)).map(g => g.name);
    }

    public get excludedGroupNames(): string[] {
        return this.groups.filter(g => this.excludedGroupIds.has(g.id)).map(g => g.name);
    }

    public get includedNodeNames(): string[] {
        return Array.from(this.selectedNodeIds).map((id: any) => {
            const node = this.nodeCache[Number(id)];
            return node ? node.name : `Node ${id}`;
        });
    }

    public get excludedNodeNames(): string[] {
        return Array.from(this.excludedNodeIds).map((id: any) => {
            const node = this.nodeCache[Number(id)];
            return node ? node.name : `Node ${id}`;
        });
    }

    private generateRelayName(): string {
        const now = new Date();
        const pad = (n: number) => String(n).padStart(2, '0');
        return `Relay-${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
    }

    private beginWizardStepLoad(step: number): number {
        this.wizardLoadToken += 1;
        this.wizardLoadingStep = step;
        this.wizardStepError = '';
        return this.wizardLoadToken;
    }

    private isWizardLoadCurrent(token: number): boolean {
        return this.showWizard && token === this.wizardLoadToken;
    }

    private finishWizardStepLoad(token: number) {
        if (this.isWizardLoadCurrent(token)) {
            this.wizardLoadingStep = 0;
        }
    }

    private cancelWizardStepLoad() {
        this.wizardLoadToken += 1;
        this.wizardLoadingStep = 0;
        this.wizardStepError = '';
    }

    private normalizeRelayStatus(value: any): string {
        return String(value || '').trim().toLowerCase();
    }

    private relayImageMatches(server: any): boolean {
        const selectedImageId = String(this.selectedImageId || '').trim();
        if (!selectedImageId) return true;
        return String(server?.image_id || '').trim() === selectedImageId;
    }

    private relayDeploymentStateFromNode(server: any): any {
        const status = this.normalizeRelayStatus(server?.status);
        const deployStatus = this.normalizeRelayStatus(server?.deploy_status);
        const imageMatches = this.relayImageMatches(server);
        const failed = status === 'failed' || status === 'error' || deployStatus.endsWith('failed');
        const ready = imageMatches && !failed && status === 'relay-ready';
        const deployed = imageMatches && !ready && !failed && (
            ['deployed', 'commissioned', 'active'].includes(status) ||
            ['deployed', 'active'].includes(deployStatus)
        );
        const deploying = imageMatches && !ready && !deployed && !failed && (
            status.includes('deploy') ||
            status.includes('diskless') ||
            status.includes('commission') ||
            deployStatus.includes('deploy') ||
            deployStatus.includes('diskless') ||
            deployStatus.includes('commission')
        );
        return {
            imageDeployed: ready || deployed || deploying,
            ready,
            osReady: ready,
            status: ready ? 'relay-ready' : (deployed ? 'deployed' : (deployStatus || status)),
            message: imageMatches ? '' : 'Selected image does not match current node image'
        };
    }

    private syncRelayDeploymentStatusFromNodes() {
        const nextStatus: any = {};
        for (const server of this.relayServers || []) {
            nextStatus[server.id] = this.relayDeploymentStateFromNode(server);
        }
        this.deploymentStatus = nextStatus;
    }

    // Back step: clear current step cache, go to previous step
    public async goBackStep() {
        const current = this.wizardStep;
        if (current <= 0) return;
        this.cancelWizardStepLoad();
        // Clear current step cache
        if (current === 1) {
            this.activeNodeTab = 'group';
            this.selectedGroupIds = new Set();
            this.excludedGroupIds = new Set();
            this.selectedNodeIds = new Set();
            this.excludedNodeIds = new Set();
            this.groups = [];
            this.allNodes = [];
            this.filterGroupId = '';
            this.nodeSearchText = '';
            this.showNodeRangeFilter = false;
            this.nodeRangeFilter = { idStart: '', idEnd: '', bmcStart: '', bmcEnd: '' };
            this.appliedNodeRangeFilter = { idStart: '', idEnd: '', bmcStart: '', bmcEnd: '' };
            this.nodeRangeActive = false;
            this.nodePage = 1;
            this.nodeTotal = 0;
            this.nodeCache = {};
        } else if (current === 2) {
            this.selectedServerIds = new Set();
            this.candidateNodes = [];
            this.resetTemplateRelayMappingState();
        } else if (current === 3) {
            this.selectedImageId = '';
            this.deploymentStatus = {};
            this.relayServers = [];
            this.computingNodes = [];
        } else if (current === 4) {
            this.assignments = {};
            this.selectedRelayServerId = null;
            this.relayName = '';
        } else if (current === 5) {
            this.deployStarted = false;
            this.poweredOff = false;
            this.poweringOff = false;
            this.poweringOn = false;
            this.deployCompleted = false;
            this.nodeDeployStatus = {};
            this.preflightLoading = false;
            this.preflightReport = null;
            this.allowKnownBlockerOverride = false;
            this.orchestrationJobId = '';
            this.orchestrationJob = null;
            if (this.deployCheckInterval) {
                clearInterval(this.deployCheckInterval);
                this.deployCheckInterval = null;
            }
        }
        this.wizardStep = current - 1;
        await this.service.render();
    }

    public async goStep(step: number) {
        this.wizardStepError = '';
        if (step !== 2 && step !== 3) {
            this.cancelWizardStepLoad();
        }
        if (step === 2) {
            if (this.selectedGroupIds.size === 0 && this.selectedNodeIds.size === 0) return;
            const token = this.beginWizardStepLoad(2);
            this.wizardStep = 2;
            this.candidateNodes = [];
            this.candidateTotal = 0;
            this.selectedServerIds = new Set();
            await this.service.render();

            try {
                await this.loadRelaySubnets();
                const { code, data } = await wiz.call("nodes", {
                    mode: "selection",
                    page: 1,
                    dump: 5000,
                    include_groups: JSON.stringify(Array.from(this.selectedGroupIds)),
                    include_nodes: JSON.stringify(Array.from(this.selectedNodeIds)),
                    exclude_groups: JSON.stringify(Array.from(this.excludedGroupIds)),
                    exclude_nodes: JSON.stringify(Array.from(this.excludedNodeIds)),
                });
                if (!this.isWizardLoadCurrent(token)) return;
                if (code !== 200) {
                    this.wizardStepError = data?.message || 'Failed to load relay candidates.';
                    return;
                }
                this.candidateNodes = data.rows || [];
                this.candidateTotal = data.total || this.candidateNodes.length;
                this.cacheNodes(this.candidateNodes);
                if (data.truncated) {
                    this.wizardStepError = `Relay candidate preview is limited to ${this.candidateNodes.length} nodes. Narrow the selection before continuing.`;
                    this.candidateNodes = [];
                    return;
                }
                if (this.candidateNodes.length === 0) {
                    this.wizardStepError = 'No candidate nodes matched this selection.';
                }
            } catch (e) {
                if (this.isWizardLoadCurrent(token)) {
                    this.wizardStepError = `Failed to load relay candidates: ${String(e)}`;
                }
            } finally {
                if (this.isWizardLoadCurrent(token)) {
                    this.finishWizardStepLoad(token);
                    await this.service.render();
                }
            }
            return;
        } else if (step === 3) {
            this.ensureDhcpAuthorityGroups();
            if (!this.hasValidDhcpAuthorityGroups) {
                this.wizardStepError = this.dhcpAuthoritySubnetDuplicateMessage || 'Select an Authority and subnet for every selected relay server.';
                await this.service.render();
                return;
            }
            this.relayServers = this.candidateNodes.filter(n => this.selectedServerIds.has(n.id));
            this.computingNodes = this.candidateNodes.filter(n => !this.selectedServerIds.has(n.id));
            this.images = [];
            // Init deployment status
            this.syncRelayDeploymentStatusFromNodes();
            // Dummy: pre-mark all as ready
            if (this.useDummy) {
                const status: any = {};
                this.relayServers.forEach((s: any) => { status[s.id] = { imageDeployed: true, ready: true, osReady: true }; });
                this.deploymentStatus = status;
            }
            const token = this.beginWizardStepLoad(3);
            this.wizardStep = 3;
            await this.service.render();

            try {
                const { code, data } = await wiz.call("images");
                if (!this.isWizardLoadCurrent(token)) return;
                if (code === 200) this.images = data || [];
                else this.wizardStepError = data?.message || 'Failed to load images.';
            } catch (e) {
                if (this.isWizardLoadCurrent(token)) {
                    this.wizardStepError = `Failed to load images: ${String(e)}`;
                }
            } finally {
                if (this.isWizardLoadCurrent(token)) {
                    this.finishWizardStepLoad(token);
                    await this.service.render();
                }
            }
            return;
        } else if (step === 4) {
            // Auto-generate relay name
            this.relayName = this.generateRelayName();
            // Init assignments: serverId → []
            const asgn: any = {};
            this.relayServers.forEach((rs: any) => { asgn[rs.id] = []; });
            this.assignments = asgn;
            this.autoAssignComputingNodesByAuthoritySubnet();
            this.selectedRelayServerId = this.firstAssignedRelayServerId() || (this.relayServers.length > 0 ? this.relayServers[0].id : null);
        } else if (step === 5) {
            this.deployStarted = false;
            this.poweredOff = false;
            this.poweringOff = false;
            this.poweringOn = false;
            this.deployCompleted = false;
            this.step5ImageId = this.selectedImageId || '';
            this.nodeDeployStatus = {};
            this.setPreflightReport(null);
            this.allowKnownBlockerOverride = false;
            this.orchestrationJobId = '';
            this.setOrchestrationJob(null);
            // Initialize per-node deploy status
            this.computingNodes.forEach((cn: any) => {
                this.nodeDeployStatus[cn.id] = { status: 'pending' };
            });
            this.updateDeployStats();
            this.wizardStep = step;
            await this.service.render();
            this.initializeStep5();
            return;
        }
        this.wizardStep = step;
        await this.service.render();
    }

    private async initializeStep5() {
        await this.refreshPowerStatus();
        const syncedJob = await this.syncPersistedOrchestrationJob();
        if (syncedJob && this.orchestrationJob && !['completed', 'failed'].includes(this.orchestrationJob.status) && !this.deployCheckInterval) {
            this.startOrchestrationPoll();
        }
        if (!this.useDummy) {
            await this.runPreflight();
        }
        await this.service.render();
    }

    // Step 1 group tab helpers
    public toggleGroupInclude(id: number) {
        if (this.selectedGroupIds.has(id)) this.selectedGroupIds.delete(id);
        else { this.selectedGroupIds.add(id); this.excludedGroupIds.delete(id); }
        this.service.render();
    }
    public toggleGroupExclude(id: number) {
        if (this.excludedGroupIds.has(id)) this.excludedGroupIds.delete(id);
        else { this.excludedGroupIds.add(id); this.selectedGroupIds.delete(id); }
        this.service.render();
    }
    public isGroupIncluded(id: number) { return this.selectedGroupIds.has(id); }
    public isGroupExcluded(id: number) { return this.excludedGroupIds.has(id); }
    public get canGoStep2FromGroups() { return this.selectedGroupIds.size > 0 || this.selectedNodeIds.size > 0; }

    private resetTemplateRelayMappingState() {
        this.templateRelayMappings = [];
        this.templateRelayCandidates = [];
        this.relayMappingCriteria = [];
        this.relayCandidateSearchText = '';
        this.relayCandidateStatusFilter = 'all';
        this.relayCandidatePage = 1;
        this.relayMappingAutoRunning = false;
    }

    private normalizeTemplateRelayCandidate(node: any): any {
        const item = { ...(node || {}) };
        item.id = Number(item.id || item.node_id || 0);
        item.candidate_status = item.candidate_status || 'available';
        item.status = item.status || 'ready';
        return item;
    }

    private findTemplateRelayCandidate(nodeId: any): any {
        const id = Number(nodeId || 0);
        if (!id) return null;
        return (this.templateRelayCandidates || []).find((item: any) => Number(item.id || 0) === id) || null;
    }

    private normalizeTemplateRelayNode(node: any, mapping?: any): any {
        const item = this.normalizeTemplateRelayCandidate(node);
        if (!item.id) return item;
        item.template_role = 'relay';
        item.template_row = mapping?.row_number || item.template_row || '';
        item.template_node_name = mapping?.template_hostname || mapping?.template_relay_name || item.template_node_name || '';
        item.template_bmc_mac = mapping?.template_bmc_mac || item.template_bmc_mac || '';
        item.template_provisioning_mac = mapping?.template_provisioning_mac || item.template_provisioning_mac || '';
        item.template_serial_number = mapping?.template_serial_number || item.template_serial_number || '';
        item.template_node_identity = mapping?.template_node_identity || item.template_node_identity || '';
        item.template_match_type = mapping?.match_type || item.template_match_type || 'manual';
        item.template_match_label = mapping?.match_label || item.template_match_label || '수동 선택';
        item.relay_ref = mapping?.relay_ref || item.relay_ref || '';
        item.group_name = mapping?.group_name || mapping?.cpu_group || item.group_name || '';
        item.cluster_name = mapping?.cluster_name || item.cluster_name || '';
        item.dhcp_subnet_key = mapping?.dhcp_subnet_key || item.dhcp_subnet_key || '';
        item.dhcp_group_key = mapping?.dhcp_group_key || item.dhcp_group_key || item.dhcp_subnet_key || '';
        if (mapping && (item.is_dhcp_server === undefined || item.is_dhcp_server === null || item.is_dhcp_server === '')) {
            item.is_dhcp_server = Number(mapping.is_dhcp_server || 0);
        }
        return item;
    }

    private ensureTemplateCandidateNode(node: any, mapping?: any): any {
        const normalized = this.normalizeTemplateRelayNode(node, mapping);
        if (!normalized.id) return null;
        const existing = this.candidateNodes.find((item: any) => Number(item.id || 0) === normalized.id);
        if (existing) {
            Object.assign(existing, {
                ...normalized,
                id: existing.id,
                name: existing.name || normalized.name,
                mac_address: existing.mac_address || normalized.mac_address,
                ip_address: existing.ip_address || normalized.ip_address,
                bmc_ip: existing.bmc_ip || normalized.bmc_ip,
            });
            this.initializeRelayDhcpDefaults(existing);
            return existing;
        }
        this.initializeRelayDhcpDefaults(normalized);
        this.candidateNodes.push(normalized);
        this.cacheNodes([normalized]);
        return normalized;
    }

    private defaultRelayMappingCriteria(): any[] {
        return [
            { key: 'hostname', label: 'Hostname' },
            { key: 'bmc_mac', label: 'BMC MAC' },
            { key: 'provisioning_mac', label: 'Provisioning MAC' },
            { key: 'serial_number', label: 'Serial Number' },
            { key: 'node_identity', label: 'Node Identity' },
        ];
    }

    private initializeTemplateRelayMappings() {
        const mappings = this.templatePreview?.relay_mappings || [];
        this.relayMappingCriteria = this.templatePreview?.mapping_priority || this.defaultRelayMappingCriteria();
        this.templateRelayCandidates = (this.templatePreview?.relay_candidates || [])
            .map((node: any) => this.normalizeTemplateRelayCandidate(node))
            .filter((node: any) => node.id > 0);
        this.relayCandidateSearchText = '';
        this.relayCandidateStatusFilter = 'all';
        this.relayCandidatePage = 1;

        this.templateRelayMappings = (mappings || []).map((mapping: any, index: number) => {
            const selectedNodeId = Number(mapping?.selected_node_id || mapping?.selected_node?.id || 0);
            const selectedNode = mapping?.selected_node || this.findTemplateRelayCandidate(selectedNodeId);
            return {
                ...mapping,
                row_key: mapping?.row_key || `relay-${index}`,
                selected_node_id: selectedNodeId || '',
                selected_node: selectedNode || null,
                original_node_id: selectedNodeId || '',
                status: selectedNodeId ? 'mapped' : 'manual_required',
            };
        });

        if (this.templateRelayMappings.length === 0) {
            this.templateRelayMappings = (this.candidateNodes || [])
                .filter((node: any) => String(node.template_role || '').toLowerCase() === 'relay')
                .map((node: any, index: number) => ({
                    row_key: `matched-${node.id || index}`,
                    row_number: node.template_row || '',
                    template_relay_name: node.template_node_name || node.name || `Relay ${index + 1}`,
                    template_hostname: node.template_node_name || node.name || '',
                    cpu_group: node.group_name || node.cluster_name || '',
                    selected_node_id: Number(node.id || 0),
                    selected_node: node,
                    original_node_id: Number(node.id || 0),
                    match_type: node.template_match_type || 'hostname',
                    match_label: node.template_match_label || 'Hostname 일치',
                    status: 'mapped',
                    dhcp_subnet_key: node.dhcp_subnet_key || '',
                    dhcp_group_key: node.dhcp_group_key || '',
                    is_dhcp_server: Number(node.is_dhcp_server || 0),
                }));
        }

        this.applyTemplateRelayMappingsToSelection();
    }

    private applyTemplateRelayMappingsToSelection() {
        const selected = new Set<number>();
        if (this.wizardMode === 'template') {
            this.candidateNodes = (this.candidateNodes || []).filter((node: any) =>
                String(node?.template_role || '').toLowerCase() !== 'relay'
            );
        }
        for (const mapping of this.templateRelayMappings || []) {
            const nodeId = Number(mapping?.selected_node_id || 0);
            if (!nodeId) continue;
            const source = mapping.selected_node || this.findTemplateRelayCandidate(nodeId) || this.nodeCache[nodeId];
            const node = this.ensureTemplateCandidateNode(source, mapping);
            if (node?.id) {
                mapping.selected_node = node;
                selected.add(Number(node.id));
            }
        }
        this.selectedServerIds = selected;
        this.ensureDhcpAuthorityGroups();
    }

    public runTemplateAutoMapping() {
        this.relayMappingAutoRunning = true;
        this.initializeTemplateRelayMappings();
        this.relayMappingAutoRunning = false;
        this.service.render();
    }

    public clearTemplateRelayMappings() {
        for (const mapping of this.templateRelayMappings || []) {
            mapping.selected_node_id = '';
            mapping.selected_node = null;
            mapping.status = 'manual_required';
            mapping.match_type = '';
            mapping.match_label = '';
        }
        this.selectedServerIds = new Set();
        this.applyTemplateRelayMappingsToSelection();
        this.service.render();
    }

    public onTemplateRelayMappingChanged(mapping: any, nodeId: any) {
        const selectedId = Number(nodeId || 0);
        if (!mapping) return;
        if (!selectedId) {
            mapping.selected_node_id = '';
            mapping.selected_node = null;
            mapping.status = 'manual_required';
            mapping.match_type = '';
            mapping.match_label = '';
        } else {
            const candidate = this.findTemplateRelayCandidate(selectedId);
            mapping.selected_node_id = selectedId;
            mapping.selected_node = candidate || this.nodeCache[selectedId] || { id: selectedId };
            if (Number(mapping.original_node_id || 0) !== selectedId) {
                mapping.status = 'manual_mapped';
                mapping.match_type = 'manual';
                mapping.match_label = '수동 선택';
            } else {
                mapping.status = 'mapped';
            }
        }
        this.applyTemplateRelayMappingsToSelection();
        this.service.render();
    }

    public assignRelayCandidateToFirstManualMapping(candidate: any) {
        const mapping = (this.templateRelayMappings || []).find((item: any) => !Number(item.selected_node_id || 0))
            || (this.templateRelayMappings || []).find((item: any) => this.relayMappingStatus(item) === 'duplicate');
        if (!mapping || !candidate) return;
        this.onTemplateRelayMappingChanged(mapping, candidate.id);
    }

    private duplicateRelayMappingIds(): Set<number> {
        const counts: any = {};
        for (const mapping of this.templateRelayMappings || []) {
            const id = Number(mapping.selected_node_id || 0);
            if (!id) continue;
            counts[id] = (counts[id] || 0) + 1;
        }
        return new Set(
            Object.keys(counts)
                .filter((id: string) => counts[id] > 1)
                .map((id: string) => Number(id))
        );
    }

    public relayMappingStatus(mapping: any): string {
        const selectedId = Number(mapping?.selected_node_id || 0);
        if (!selectedId) return 'manual_required';
        if (this.duplicateRelayMappingIds().has(selectedId)) return 'duplicate';
        if (mapping?.match_type === 'manual' || mapping?.status === 'manual_mapped') return 'manual_mapped';
        return 'mapped';
    }

    public relayMappingStatusLabel(mapping: any): string {
        const status = this.relayMappingStatus(mapping);
        const labels: any = {
            mapped: '매핑됨',
            manual_mapped: '수동 선택',
            manual_required: '수동 선택 필요',
            duplicate: '중복 선택',
        };
        return labels[status] || status;
    }

    public relayMappingStatusClass(mapping: any): string {
        const status = this.relayMappingStatus(mapping);
        const classes: any = {
            mapped: 'bg-emerald-100 text-emerald-700',
            manual_mapped: 'bg-blue-100 text-blue-700',
            manual_required: 'bg-amber-100 text-amber-700',
            duplicate: 'bg-red-100 text-red-700',
        };
        return classes[status] || 'bg-zinc-100 text-zinc-600';
    }

    public relayMappingReasonLabel(mapping: any): string {
        const status = this.relayMappingStatus(mapping);
        if (status === 'manual_required') return '자동 매핑 실패';
        if (status === 'duplicate') return '같은 노드가 둘 이상의 Relay 역할에 선택됨';
        return mapping?.match_label || '수동 선택';
    }

    public relayMappingReasonClass(mapping: any): string {
        const status = this.relayMappingStatus(mapping);
        if (status === 'manual_required') return 'text-amber-700';
        if (status === 'duplicate') return 'text-red-700';
        if (status === 'manual_mapped') return 'text-blue-700';
        return 'text-zinc-600';
    }

    public relayMappingNodeLabel(node: any): string {
        if (!node) return '-';
        const name = String(node.name || `Node ${node.id || ''}`).trim();
        const ip = String(node.ip_address || node.bmc_ip || '').trim();
        return ip ? `${name} (${ip})` : name;
    }

    public relayCandidateAvailability(candidate: any): string {
        const id = Number(candidate?.id || 0);
        if (id && this.selectedServerIds.has(id)) return 'mapped';
        return candidate?.candidate_status === 'unavailable' ? 'unavailable' : 'available';
    }

    public relayCandidateAvailabilityLabel(candidate: any): string {
        const status = this.relayCandidateAvailability(candidate);
        const labels: any = {
            available: '사용 가능',
            mapped: '이미 사용중',
            unavailable: '사용 불가',
        };
        return labels[status] || status;
    }

    public relayCandidateAvailabilityClass(candidate: any): string {
        const status = this.relayCandidateAvailability(candidate);
        const classes: any = {
            available: 'text-emerald-700',
            mapped: 'text-indigo-700',
            unavailable: 'text-zinc-400',
        };
        return classes[status] || 'text-zinc-500';
    }

    public get filteredRelayCandidates(): any[] {
        const text = String(this.relayCandidateSearchText || '').trim().toLowerCase();
        return (this.templateRelayCandidates || []).filter((candidate: any) => {
            const availability = this.relayCandidateAvailability(candidate);
            if (this.relayCandidateStatusFilter !== 'all' && availability !== this.relayCandidateStatusFilter) return false;
            if (!text) return true;
            const haystack = [
                candidate.name,
                candidate.ip_address,
                candidate.bmc_ip,
                candidate.mac_address,
                candidate.bmc_mac,
                candidate.group_name,
                candidate.cluster_name,
            ].map((value: any) => String(value || '').toLowerCase()).join(' ');
            return haystack.includes(text);
        });
    }

    public get pagedRelayCandidates(): any[] {
        const start = (this.relayCandidatePage - 1) * this.relayCandidateDump;
        return this.filteredRelayCandidates.slice(start, start + this.relayCandidateDump);
    }

    public relayCandidateTotalPages(): number {
        return Math.ceil(this.filteredRelayCandidates.length / this.relayCandidateDump) || 1;
    }

    public relayCandidatePageList(): number[] {
        const total = this.relayCandidateTotalPages();
        const current = this.relayCandidatePage;
        const pages: number[] = [];
        const start = Math.max(1, current - 2);
        const end = Math.min(total, current + 2);
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public changeRelayCandidateFilter() {
        this.relayCandidatePage = 1;
        this.service.render();
    }

    public get templateRelayCount(): number { return this.templateRelayMappings.length; }
    public get registeredRelayCandidateCount(): number { return this.templateRelayCandidates.length; }
    public get autoMappedRelayCount(): number {
        return this.templateRelayMappings.filter((mapping: any) => this.relayMappingStatus(mapping) === 'mapped').length;
    }
    public get manualRelayRequiredCount(): number {
        return this.templateRelayMappings.filter((mapping: any) => this.relayMappingStatus(mapping) === 'manual_required').length;
    }
    public get relayMappingFailedCount(): number {
        return this.templateRelayMappings.filter((mapping: any) => {
            const status = this.relayMappingStatus(mapping);
            return status === 'manual_required' || status === 'duplicate';
        }).length;
    }
    public get relayMappingDuplicateCount(): number { return this.duplicateRelayMappingIds().size; }
    public get relayMappingSuccessRate(): string {
        if (!this.templateRelayCount) return '0.0';
        return ((this.autoMappedRelayCount / this.templateRelayCount) * 100).toFixed(1);
    }
    public get templateRelayMappingsComplete(): boolean {
        return this.templateRelayMappings.length > 0
            && this.templateRelayMappings.every((mapping: any) => Number(mapping.selected_node_id || 0) > 0)
            && this.relayMappingDuplicateCount === 0;
    }
    public get relayMappingFailedRows(): any[] {
        return (this.templateRelayMappings || []).filter((mapping: any) => {
            const status = this.relayMappingStatus(mapping);
            return status === 'manual_required' || status === 'duplicate';
        });
    }

    // Step 2 helpers
    public toggleServerSelect(id: number) {
        const node = this.candidateNodes.find((item: any) => String(item.id) === String(id));
        if (this.selectedServerIds.has(id)) {
            this.selectedServerIds.delete(id);
            if (node) node.is_dhcp_server = 0;
        } else {
            this.selectedServerIds.add(id);
            if (node) this.initializeRelayDhcpDefaults(node);
        }
        this.ensureDhcpAuthorityGroups();
        this.service.render();
    }

    public isServerSelected(id: number) { return this.selectedServerIds.has(id); }
    public get serverCount() { return this.selectedServerIds.size; }
    public get dhcpServerCount() {
        return this.candidateNodes.filter((node: any) => this.isServerSelected(node.id) && this.isDhcpServer(node)).length;
    }

    private defaultDhcpGroupKey(node: any): string {
        const subnetId = String(node?.dhcp_domain_subnet_id || '').trim();
        if (subnetId) return `id:${subnetId}`;
        const domainKey = String(node?.dhcp_domain_key || '').trim();
        if (domainKey) return domainKey;
        const vlanId = String(node?.dhcp_domain_vlan_id || '').trim();
        if (vlanId && vlanId !== '0') return `vlan:${vlanId}`;
        const cidr = String(node?.dhcp_domain_cidr || '').trim();
        if (cidr) return `cidr:${cidr}`;
        return 'default';
    }

    private dhcpAuthorityGroupKey(node: any): string {
        const nodeId = String(node?.id || node?.node_id || '').trim();
        return nodeId ? `authority:${nodeId}` : this.defaultDhcpGroupKey(node);
    }

    public getDhcpGroupKey(node: any): string {
        const storedKey = String(node?.dhcp_group_key || '').trim();
        if (this.isDhcpServer(node)) {
            return storedKey.startsWith('authority:') ? storedKey : this.dhcpAuthorityGroupKey(node);
        }
        return storedKey || '';
    }

    public getDhcpSubnetKey(node: any): string {
        const subnetKey = String(node?.dhcp_subnet_key || '').trim();
        if (subnetKey) return this.canonicalDhcpSubnetKey(subnetKey);
        const storedKey = String(node?.dhcp_group_key || '').trim();
        if (storedKey && !storedKey.startsWith('authority:')) return this.canonicalDhcpSubnetKey(storedKey);
        return this.defaultDhcpGroupKey(node);
    }

    public getDhcpGroupLabel(node: any): string {
        const subnet = this.getDhcpSubnetForKey(this.getDhcpSubnetKey(node));
        if (subnet) return subnet.label;
        return String(node?.dhcp_domain_label || '').trim() || this.getDhcpSubnetKey(node);
    }

    public getDhcpSubnetForKey(key: any): any {
        const normalized = String(key || '').trim();
        if (!normalized) return null;
        return (this.relaySubnets || []).find((subnet: any) => {
            if (String(subnet.key || '').trim() === normalized) return true;
            return (subnet.aliases || []).some((alias: any) => String(alias || '').trim() === normalized);
        }) || null;
    }

    private canonicalDhcpSubnetKey(key: any): string {
        const normalized = String(key || '').trim();
        if (!normalized) return '';
        const subnet = this.getDhcpSubnetForKey(normalized);
        return String(subnet?.key || normalized).trim();
    }

    public getDhcpSubnetOptionsForNode(node: any): any[] {
        const key = this.getDhcpSubnetKey(node);
        const options = [...(this.relaySubnets || [])];
        if (key && !this.getDhcpSubnetForKey(key) && !key.startsWith('authority:')) {
            options.unshift({
                key,
                label: String(node?.dhcp_domain_label || '').trim() || key,
            });
        }
        return options;
    }

    private relayFlagEnabled(value: any, defaultValue: boolean = false): boolean {
        if (value === undefined || value === null || value === '') return defaultValue;
        if (typeof value === 'boolean') return value;
        if (typeof value === 'number') return value !== 0;
        const text = String(value).trim().toLowerCase();
        if (['1', 'true', 'yes', 'on', 'enable', 'enabled', 'dhcp', 'authority'].includes(text)) return true;
        if (['0', 'false', 'no', 'off', 'disable', 'disabled', 'relay', 'member'].includes(text)) return false;
        return defaultValue;
    }

    private initializeRelayDhcpDefaults(node: any) {
        if (!node) return;
        if (node.is_dhcp_server === undefined || node.is_dhcp_server === null || node.is_dhcp_server === '') {
            node.is_dhcp_server = 0;
        }
        const storedKey = String(node.dhcp_group_key || '').trim();
        if (!String(node.dhcp_subnet_key || '').trim()) {
            node.dhcp_subnet_key = storedKey && !storedKey.startsWith('authority:')
                ? storedKey
                : this.defaultDhcpGroupKey(node);
        }
        node.dhcp_subnet_key = this.canonicalDhcpSubnetKey(node.dhcp_subnet_key) || node.dhcp_subnet_key;
        if (this.isDhcpServer(node)) {
            node.dhcp_group_key = this.dhcpAuthorityGroupKey(node);
        }
    }

    private selectedRelayCandidates(): any[] {
        return this.candidateNodes.filter((node: any) => this.isServerSelected(node.id));
    }

    private ensureDhcpAuthorityGroups() {
        const candidates = this.selectedRelayCandidates();
        for (const node of candidates) {
            this.initializeRelayDhcpDefaults(node);
        }
        if (candidates.length > 0 && !candidates.some((node: any) => this.isDhcpServer(node))) {
            candidates[0].is_dhcp_server = 1;
            candidates[0].dhcp_group_key = this.promotedDhcpAuthorityGroupKey(candidates[0]);
            candidates[0].dhcp_subnet_key = this.promotedDhcpAuthoritySubnetKey(candidates[0]);
        }

        const authorities = candidates.filter((node: any) => this.isDhcpServer(node));
        const authorityKeys = new Set(authorities.map((node: any) => this.getDhcpGroupKey(node)));
        for (const node of candidates) {
            if (this.isDhcpServer(node)) continue;
            const currentKey = this.getDhcpGroupKey(node);
            if (currentKey && authorityKeys.has(currentKey)) continue;

            const subnetKey = this.getDhcpSubnetKey(node);
            const matchingAuthority = authorities.find((authority: any) =>
                this.getDhcpSubnetKey(authority) === subnetKey
            );
            if (matchingAuthority) {
                node.dhcp_group_key = this.getDhcpGroupKey(matchingAuthority);
                node.dhcp_subnet_key = this.getDhcpSubnetKey(matchingAuthority);
            }
        }
    }

    public isDhcpServer(node: any): boolean {
        return this.relayFlagEnabled(node?.is_dhcp_server, false);
    }

    public getDhcpAuthorityForServer(server: any): any {
        if (!server) return null;
        if (this.isDhcpServer(server)) return server;
        const groupKey = this.getDhcpGroupKey(server);
        if (!groupKey) return null;
        const source = (this.relayServers && this.relayServers.length > 0)
            ? this.relayServers
            : this.selectedRelayCandidates();
        return (source || []).find((item: any) =>
            this.getDhcpGroupKey(item) === groupKey && this.isDhcpServer(item)
        ) || null;
    }

    public getDhcpAuthorityNameForServer(server: any): string {
        const authority = this.getDhcpAuthorityForServer(server);
        if (!authority) return 'Not selected';
        const name = String(authority.name || 'Node').trim();
        return `${name} (#${authority.id})`;
    }

    public getDhcpAuthorityMetaForServer(server: any): string {
        const authority = this.getDhcpAuthorityForServer(server);
        const groupLabel = this.getDhcpGroupLabel(server);
        const ip = String(authority?.ip_address || authority?.bmc_ip || '').trim();
        return ip ? `${groupLabel} · ${ip}` : groupLabel;
    }

    public getDhcpAuthoritySummaries(): any[] {
        const source = (this.relayServers && this.relayServers.length > 0)
            ? this.relayServers
            : this.selectedRelayCandidates();
        const groups: any = {};

        for (const node of source) {
            const key = this.getDhcpGroupKey(node);
            if (!groups[key]) {
                groups[key] = {
                    key,
                    label: this.getDhcpGroupLabel(node),
                    authority: null,
                    members: []
                };
            }
            groups[key].members.push(node);
            if (this.isDhcpServer(node)) {
                groups[key].authority = node;
                groups[key].label = this.getDhcpGroupLabel(node);
            }
        }

        return (Object.values(groups) as any[]).sort((a: any, b: any) =>
            String(a.label || a.key).localeCompare(String(b.label || b.key))
        );
    }

    private duplicateDhcpAuthoritySubnets(): any[] {
        const seen: any = {};
        const duplicates: any = {};
        for (const authority of this.selectedRelayCandidates().filter((node: any) => this.isDhcpServer(node))) {
            const subnetKey = String(this.getDhcpSubnetKey(authority) || '').trim();
            const normalizedKey = subnetKey.toLowerCase();
            if (!normalizedKey) continue;
            const label = this.getDhcpGroupLabel(authority);
            if (seen[normalizedKey]) {
                duplicates[normalizedKey] = seen[normalizedKey].label || label || subnetKey;
            } else {
                seen[normalizedKey] = { key: subnetKey, label };
            }
        }
        return Object.values(duplicates);
    }

    public get hasDuplicateDhcpAuthoritySubnets(): boolean {
        return this.duplicateDhcpAuthoritySubnets().length > 0;
    }

    public get dhcpAuthoritySubnetDuplicateMessage(): string {
        const duplicates = this.duplicateDhcpAuthoritySubnets();
        if (duplicates.length === 0) return '';
        const labels = duplicates.map((item: any) => String(item || '').trim()).filter((item: string) => !!item).join(', ');
        return `Authority 서브넷이 중복되었습니다: ${labels || 'unknown'}. 서브넷당 Authority는 1개만 선택하세요.`;
    }

    public getDhcpAuthorityOptions(excludeNode?: any): any[] {
        return this.selectedRelayCandidates()
            .filter((node: any) => this.isDhcpServer(node) && String(node.id) !== String(excludeNode?.id || ''))
            .map((node: any) => {
                const groupKey = this.getDhcpGroupKey(node);
                return {
                    node,
                    groupKey,
                    label: `${node.name || 'Node'} (#${node.id})`,
                    meta: this.getDhcpGroupLabel(node),
                };
            });
    }

    public getDhcpAuthorityMembershipLabel(node: any): string {
        const authority = this.getDhcpAuthorityForServer(node);
        if (!authority) return 'No authority selected';
        return `${authority.name || 'Node'} (#${authority.id})`;
    }

    private promotedDhcpAuthorityGroupKey(node: any): string {
        return this.dhcpAuthorityGroupKey(node);
    }

    private promotedDhcpAuthoritySubnetKey(node: any): string {
        const currentKey = String(node?.dhcp_subnet_key || node?.dhcp_group_key || '').trim();
        const defaultKey = this.defaultDhcpGroupKey(node);
        if (currentKey && !currentKey.startsWith('authority:')) return currentKey;
        return defaultKey;
    }

    public setDhcpRole(node: any, role: string, event?: Event) {
        if (event) event.stopPropagation();
        if (!node || !this.isServerSelected(node.id)) return;
        this.initializeRelayDhcpDefaults(node);
        if (role === 'authority') {
            node.dhcp_group_key = this.promotedDhcpAuthorityGroupKey(node);
            node.dhcp_subnet_key = this.promotedDhcpAuthoritySubnetKey(node);
            node.is_dhcp_server = 1;
            this.setDhcpAuthority(node);
            return;
        }

        node.is_dhcp_server = 0;
        const currentAuthority = this.getDhcpAuthorityForServer(node);
        const fallbackAuthority = currentAuthority || this.getDhcpAuthorityOptions(node)[0]?.node;
        if (fallbackAuthority) {
            node.dhcp_group_key = this.getDhcpGroupKey(fallbackAuthority);
            node.dhcp_subnet_key = this.getDhcpSubnetKey(fallbackAuthority);
        } else {
            node.dhcp_group_key = '';
        }
        this.ensureDhcpAuthorityGroups();
        this.service.render();
    }

    public setDhcpAuthority(node: any, event?: Event) {
        if (event) event.stopPropagation();
        if (!node || !this.isServerSelected(node.id)) return;
        this.initializeRelayDhcpDefaults(node);
        node.dhcp_group_key = this.promotedDhcpAuthorityGroupKey(node);
        node.dhcp_subnet_key = this.promotedDhcpAuthoritySubnetKey(node);
        node.is_dhcp_server = 1;
        this.syncDhcpAuthorityMembers(node);
        this.service.render();
    }

    public onDhcpAuthorityMembershipChanged(node: any, event?: any) {
        if (event && typeof (event as any).stopPropagation === 'function') (event as any).stopPropagation();
        if (!node || !this.isServerSelected(node.id)) return;
        node.is_dhcp_server = 0;
        const authority = this.getDhcpAuthorityOptions(node).find((option: any) =>
            option.groupKey === String(node.dhcp_group_key || '').trim()
        )?.node;
        if (authority) {
            node.dhcp_group_key = this.getDhcpGroupKey(authority);
            node.dhcp_subnet_key = this.getDhcpSubnetKey(authority);
        }
        this.ensureDhcpAuthorityGroups();
        this.service.render();
    }

    public onDhcpGroupChanged(node: any, event?: any) {
        if (event && typeof (event as any).stopPropagation === 'function') (event as any).stopPropagation();
        if (!node || !this.isServerSelected(node.id)) return;
        node.dhcp_subnet_key = String(node.dhcp_subnet_key || '').trim() || this.defaultDhcpGroupKey(node);
        if (this.isDhcpServer(node)) {
            node.dhcp_group_key = this.dhcpAuthorityGroupKey(node);
            this.syncDhcpAuthorityMembers(node);
        }
        this.ensureDhcpAuthorityGroups();
        this.service.render();
    }

    private syncDhcpAuthorityMembers(authority: any) {
        const authorityKey = this.getDhcpGroupKey(authority);
        if (!authorityKey) return;
        const subnetKey = this.getDhcpSubnetKey(authority);
        for (const node of this.selectedRelayCandidates()) {
            if (this.isDhcpServer(node)) continue;
            if (this.getDhcpGroupKey(node) === authorityKey) {
                node.dhcp_subnet_key = subnetKey;
            }
        }
    }

    private nodeIpAddress(node: any): string {
        return String(node?.ip_address || node?.node_ip || '').trim();
    }

    private ipAddressToNumber(value: any): number | null {
        const text = String(value || '').trim();
        const parts = text.split('.');
        if (parts.length !== 4) return null;
        let result = 0;
        for (const part of parts) {
            if (!/^\d+$/.test(part)) return null;
            const octet = Number(part);
            if (octet < 0 || octet > 255) return null;
            result = (result * 256) + octet;
        }
        return result;
    }

    private cidrRange(cidr: any): any {
        const text = String(cidr || '').trim();
        const [ip, prefixText] = text.split('/');
        const base = this.ipAddressToNumber(ip);
        const prefix = Number(prefixText);
        if (base === null || !Number.isInteger(prefix) || prefix < 0 || prefix > 32) return null;
        const size = Math.pow(2, 32 - prefix);
        const start = Math.floor(base / size) * size;
        return { start, end: start + size - 1, prefix };
    }

    private authoritySubnetCidrs(authority: any): string[] {
        const cidrs: string[] = [];
        const subnetKey = this.getDhcpSubnetKey(authority);
        const subnet = this.getDhcpSubnetForKey(subnetKey);
        const subnetCidr = String(subnet?.cidr || '').trim();
        const authorityCidr = String(authority?.dhcp_domain_cidr || '').trim();
        if (subnetKey.startsWith('cidr:')) cidrs.push(subnetKey.substring(5));
        if (subnetCidr) cidrs.push(subnetCidr);
        if (authorityCidr) cidrs.push(authorityCidr);
        return Array.from(new Set(cidrs));
    }

    private authoritySubnetMatchScore(authority: any, node: any): number {
        const authorityKey = this.getDhcpSubnetKey(authority);
        const nodeKey = this.defaultDhcpGroupKey(node);
        if (authorityKey && authorityKey !== 'default' && nodeKey && nodeKey !== 'default' && authorityKey === nodeKey) {
            return 1000;
        }

        const ip = this.ipAddressToNumber(this.nodeIpAddress(node));
        if (ip === null) return 0;

        let score = 0;
        for (const cidr of this.authoritySubnetCidrs(authority)) {
            const range = this.cidrRange(cidr);
            if (range && ip >= range.start && ip <= range.end) {
                score = Math.max(score, Number(range.prefix || 0) + 1);
            }
        }
        return score;
    }

    private relayAuthorityGroups(): any[] {
        return (this.relayServers || [])
            .filter((node: any) => this.isDhcpServer(node))
            .map((authority: any) => {
                const authorityKey = this.getDhcpGroupKey(authority);
                const servers = (this.relayServers || []).filter((server: any) => {
                    if (this.isDhcpServer(server)) return String(server.id) === String(authority.id);
                    return authorityKey && this.getDhcpGroupKey(server) === authorityKey;
                });
                return { authority, servers: servers.length > 0 ? servers : [authority] };
            });
    }

    private leastAssignedRelayServer(servers: any[]): any {
        return [...(servers || [])].sort((left: any, right: any) => {
            const leftCount = (this.assignments[left.id] || []).length;
            const rightCount = (this.assignments[right.id] || []).length;
            if (leftCount !== rightCount) return leftCount - rightCount;
            return String(left.id).localeCompare(String(right.id), undefined, { numeric: true });
        })[0] || null;
    }

    private firstAssignedRelayServerId(): any {
        const server = (this.relayServers || []).find((relayServer: any) =>
            (this.assignments[relayServer.id] || []).length > 0
        );
        return server ? server.id : null;
    }

    private autoAssignComputingNodesByAuthoritySubnet() {
        const authorityGroups = this.relayAuthorityGroups();
        if (authorityGroups.length === 0) return;

        const assignedNodeIds = new Set<string>();
        Object.values(this.assignments || {}).forEach((nodeIds: any) => {
            (nodeIds || []).forEach((nodeId: any) => assignedNodeIds.add(String(nodeId)));
        });

        for (const node of this.computingNodes || []) {
            const nodeId = String(node?.id || '');
            if (!nodeId || assignedNodeIds.has(nodeId)) continue;

            const matches = authorityGroups
                .map((group: any) => ({
                    group,
                    score: this.authoritySubnetMatchScore(group.authority, node),
                }))
                .filter((match: any) => match.score > 0);
            if (matches.length === 0) continue;

            const bestScore = Math.max(...matches.map((match: any) => match.score));
            const bestMatches = matches.filter((match: any) => match.score === bestScore);
            if (bestMatches.length !== 1) continue;

            const relayServer = this.leastAssignedRelayServer(bestMatches[0].group.servers);
            if (!relayServer) continue;
            if (!this.assignments[relayServer.id]) this.assignments[relayServer.id] = [];
            this.assignments[relayServer.id].push(node.id);
            assignedNodeIds.add(nodeId);
        }
    }

    // Step 3 helpers
    public async onRelayImageChanged() {
        this.syncRelayDeploymentStatusFromNodes();
        await this.startRelayReadyChecksForDeployedServers();
        await this.service.render();
    }

    public async deployImage(serverId: any) {
        if (!this.selectedImageId) return;
        if (this.useDummy) {
            this.deploymentStatus[serverId] = { imageDeployed: true, ready: false, osReady: false };
            await this.service.render();
            setTimeout(async () => {
                this.deploymentStatus[serverId] = { imageDeployed: true, ready: true, osReady: true };
                await this.service.render();
            }, 2000);
            return;
        }
        // Real mode: call deploy API
        this.deploymentStatus[serverId] = { imageDeployed: true, ready: false, osReady: false };
        await this.service.render();
        const { code, data } = await wiz.call("deploy_server", { node_id: serverId, image_id: this.selectedImageId });
        if (code !== 200) {
            this.deploymentStatus[serverId] = { imageDeployed: false, ready: false };
            alert(data?.message || 'Deploy failed');
            await this.service.render();
            return;
        }
        // Start polling for deploy completion
        const done = await this.refreshDeployServerStatus(serverId);
        if (!done) this.pollDeployServerStatus(serverId);
    }

    private deployServerPollers: any = {};

    private async refreshDeployServerStatus(serverId: any): Promise<boolean> {
        const { code, data } = await wiz.call("deploy_server_status", {
            node_id: serverId,
            image_id: this.selectedImageId
        });
        if (code !== 200) return false;

        if (data.failed) {
            this.deploymentStatus[serverId] = {
                imageDeployed: false,
                ready: false,
                osReady: false,
                status: data.status || '',
                readyWaitRemainingSeconds: Number(data.ready_wait_remaining_seconds || 0),
                message: data.message || ''
            };
            if (this.deployServerPollers[serverId]) {
                clearInterval(this.deployServerPollers[serverId]);
                delete this.deployServerPollers[serverId];
            }
            await this.service.render();
            alert(data?.message || 'Relay server deploy failed');
            return true;
        }

        const imageMatches = data.image_matches !== false;
        const statusText = `${data.status || ''} ${data.deploy_status || ''}`.toLowerCase();
        const imageDeployed = data.image_deployed !== undefined
            ? !!data.image_deployed
            : imageMatches && (
                data.ready ||
                statusText.includes('deploy') ||
                statusText.includes('diskless') ||
                statusText.includes('commission')
            );
        this.deploymentStatus[serverId] = {
            imageDeployed,
            ready: !!data.ready,
            osReady: !!data.os_ready,
            status: data.ready ? 'relay-ready' : (data.status || ''),
            readyWaitRemainingSeconds: Number(data.ready_wait_remaining_seconds || 0),
            message: data.message || ''
        };

        if (data.ready && this.deployServerPollers[serverId]) {
            clearInterval(this.deployServerPollers[serverId]);
            delete this.deployServerPollers[serverId];
        }
        await this.service.render();
        return !!data.ready;
    }

    private pollDeployServerStatus(serverId: any) {
        if (this.deployServerPollers[serverId]) return;
        this.deployServerPollers[serverId] = setInterval(async () => {
            const done = await this.refreshDeployServerStatus(serverId);
            if (done) {
                clearInterval(this.deployServerPollers[serverId]);
                delete this.deployServerPollers[serverId];
            }
        }, 10000); // Poll every 10 seconds
    }

    private async startRelayReadyChecksForDeployedServers() {
        if (this.useDummy || !this.selectedImageId) return;
        for (const server of this.relayServers || []) {
            const state = this.deploymentStatus[server.id] || {};
            if (state.ready || !state.imageDeployed || this.deployServerPollers[server.id]) continue;
            const done = await this.refreshDeployServerStatus(server.id);
            if (!done) this.pollDeployServerStatus(server.id);
        }
    }

    public async deployAllImages() {
        if (!this.selectedImageId) return;
        const pendingServers = this.relayServers
            .filter((server: any) => !this.deploymentStatus[server.id]?.imageDeployed)
            .map((server: any) => this.deployImage(server.id));
        await Promise.all(pendingServers);
        await this.startRelayReadyChecksForDeployedServers();
    }

    public isAllReady(): boolean {
        if (this.useDummy) return true;
        return this.relayServers.length > 0 &&
            this.relayServers.every((s: any) => this.deploymentStatus[s.id]?.ready === true);
    }

    private relayServerPersistStatus(serverId: any): string {
        if (this.useDummy) return 'dummy';
        const state = this.deploymentStatus[serverId] || {};
        const status = this.normalizeRelayStatus(state.status || state.deployStatus || state.deploy_status);
        if (state.ready) return 'relay-ready';
        if (state.failed || status === 'failed' || status === 'error') return 'error';
        if (state.imageDeployed) {
            if (['deployed', 'active', 'commissioned'].includes(status)) return 'deployed';
            return 'deploying';
        }
        return 'pending';
    }

    // Step 4 helpers
    public toggleNodeForServer(nodeId: any) {
        if (!this.selectedRelayServerId) return;
        const rsId = this.selectedRelayServerId;
        if (!this.assignments[rsId]) this.assignments[rsId] = [];
        const idx = this.assignments[rsId].indexOf(nodeId);
        if (idx >= 0) {
            this.assignments[rsId].splice(idx, 1);
        } else {
            // Remove from other relay servers
            Object.keys(this.assignments).forEach(otherId => {
                if (String(otherId) !== String(rsId)) {
                    this.assignments[otherId] = this.assignments[otherId].filter((id: any) => id !== nodeId);
                }
            });
            this.assignments[rsId].push(nodeId);
        }
        this.service.render();
    }

    public isNodeAssignedToServer(nodeId: any): boolean {
        if (!this.selectedRelayServerId) return false;
        return (this.assignments[this.selectedRelayServerId] || []).includes(nodeId);
    }

    public getAssignedServerForNode(nodeId: any): any {
        for (const [rsId, nodes] of Object.entries(this.assignments)) {
            if ((nodes as any[]).includes(nodeId)) {
                return this.relayServers.find((s: any) => String(s.id) === String(rsId));
            }
        }
        return null;
    }

    public getAssignedCount(serverId: any): number {
        return (this.assignments[serverId] || []).length;
    }

    public getAssignedNodeNames(serverId: any): string {
        const ids = this.assignments[serverId] || [];
        return ids.map((id: any) => {
            const n = this.computingNodes.find(c => c.id === id || String(c.id) === String(id));
            return n ? n.name : String(id);
        }).join(', ');
    }

    public getServerName(serverId: any): string {
        const s = this.relayServers.find(r => r.id == serverId);
        return s ? s.name : '(none)';
    }

    public getRootfsSourceName(nodeId: any): string {
        const jobNode = (this.orchestrationJob?.computing_nodes || []).find((item: any) => String(item.node_id) === String(nodeId));
        if (jobNode?.relay_server_name) return jobNode.relay_server_name;
        const relayServer = this.getAssignedServerForNode(nodeId);
        return relayServer?.name || 'Main server';
    }

    public getRootfsSourceAddresses(nodeId: any): string {
        const jobNode = (this.orchestrationJob?.computing_nodes || []).find((item: any) => String(item.node_id) === String(nodeId));
        if (jobNode?.deliverer_addresses) return jobNode.deliverer_addresses;

        const preflightNode = (this.preflightReport?.computing_nodes || []).find((item: any) => String(item.id) === String(nodeId));
        const delivererCheck = (preflightNode?.checks || []).find((check: any) => check.title === 'relay deliverer preview');
        if (delivererCheck?.value) return delivererCheck.value;
        if (delivererCheck?.detail) return delivererCheck.detail;

        const relayServer = this.getAssignedServerForNode(nodeId);
        return relayServer?.ip_address || '';
    }

    // IPMI power status refresh
    public async refreshPowerStatus(shouldRender: boolean = true) {
        const allNodeIds = [
            ...this.computingNodes.map((cn: any) => cn.id),
            ...this.relayServers.map((rs: any) => rs.id)
        ];
        if (allNodeIds.length === 0) return;
        try {
            const { code, data } = await wiz.call("get_power_status", {
                data: JSON.stringify({ node_ids: allNodeIds, timeout: 5, retries: 1 })
            });
            if (code === 200 && data.results) {
                for (const cn of this.computingNodes) {
                    if (data.results[String(cn.id)]) cn.power_status = data.results[String(cn.id)];
                }
                for (const rs of this.relayServers) {
                    if (data.results[String(rs.id)]) rs.power_status = data.results[String(rs.id)];
                }
            }
        } catch (e) {
            console.warn('Power status refresh failed', e);
        }
        if (shouldRender) {
            await this.service.render();
        }
    }

    private buildRelayPayload(): any {
        const computeWindowSettings = this.normalizedComputeWindowSettings();
        return {
            name: this.relayName,
            is_dummy: this.useDummy,
            node_selection: {
                include: { groups: Array.from(this.selectedGroupIds), nodes: Array.from(this.selectedNodeIds) },
                exclude: { groups: Array.from(this.excludedGroupIds), nodes: Array.from(this.excludedNodeIds) },
                compute_window_settings: computeWindowSettings
            },
            compute_window_settings: computeWindowSettings,
            relay_servers: this.relayServers.map(n => ({
                node_id: n.id,
                image_id: this.selectedImageId,
                dhcp_group_key: this.getDhcpGroupKey(n),
                dhcp_subnet_key: this.getDhcpSubnetKey(n),
                is_dhcp_server: this.isDhcpServer(n) ? 1 : 0,
                status: this.relayServerPersistStatus(n.id),
                ready: !!this.deploymentStatus[n.id]?.ready,
            })),
            computing_nodes: Object.entries(this.assignments).flatMap(([rsId, nodeIds]: any) =>
                (nodeIds as any[]).map((nodeId: any) => ({
                    node_id: nodeId,
                    relay_server_id: rsId,
                    status: this.useDummy ? 'dummy' : 'pending'
                }))
            )
        };
    }

    private boundedInteger(value: any, defaultValue: number, minimum: number, maximum: number): number {
        const parsed = Number.parseInt(String(value), 10);
        if (Number.isNaN(parsed)) return defaultValue;
        return Math.min(maximum, Math.max(minimum, parsed));
    }

    private normalizedComputeWindowSettings(): any {
        return {
            window_size: this.boundedInteger(this.computeWindowSize, this.defaultComputeWindowSize, 1, this.maxComputeWindowSize),
            inter_window_gap_seconds: this.boundedInteger(this.computeWindowGapSeconds, this.defaultComputeWindowGapSeconds, 0, this.maxComputeWindowGapSeconds)
        };
    }

    private async ensureRelayGroupSaved(showAlert: boolean = false): Promise<string | null> {
        const payload = this.buildRelayPayload();
        if (this.createdRelayId) {
            const { code, data } = await wiz.call("update", {
                id: this.createdRelayId,
                data: JSON.stringify(payload)
            });
            if (code === 200) {
                if (showAlert) alert('Relay group saved');
                return this.createdRelayId;
            }

            alert(data?.message || 'Failed to update relay group');
            return null;
        }

        const { code, data } = await wiz.call("create", { data: JSON.stringify(payload) });
        if (code === 200 && data?.id) {
            this.createdRelayId = data.id;
            if (showAlert) alert('Relay group saved');
            return this.createdRelayId;
        }

        alert(data?.message || 'Failed to create relay group');
        return null;
    }

    public async runPreflight() {
        if (this.useDummy) {
            this.setPreflightReport({
                ok: true,
                checked_at: new Date().toISOString(),
                summary: { ok_count: 1, warning_count: 0, error_count: 0 },
                environment: [{
                    name: 'Dummy Mode',
                    status: 'ok',
                    checks: [{ status: 'ok', title: 'Dummy mode enabled', detail: 'Preflight is skipped in dummy mode.' }]
                }],
                subnets: [],
                relay_servers: [],
                computing_nodes: []
            });
            await this.service.render();
            return;
        }

        this.preflightLoading = true;
        await this.service.render();

        const payload = {
            relay_servers: this.relayServers,
            computing_nodes: this.computingNodes,
            assignments: this.assignments,
            relay_image_id: this.selectedImageId,
            computing_image_id: this.step5ImageId || this.selectedImageId,
            compute_window_settings: this.normalizedComputeWindowSettings(),
        };
        try {
            const request = wiz.call("preflight", { data: JSON.stringify(payload) });
            const timeout = new Promise(resolve => setTimeout(() => resolve({
                code: 408,
                data: { message: 'Relay preflight timed out. Check BMC/network reachability and retry.' }
            }), this.preflightRequestTimeoutMs));
            const { code, data }: any = await Promise.race([request, timeout]);
            if (code === 200) {
                this.setPreflightReport(data);
            } else {
                this.setPreflightReport(data?.report || {
                    ok: false,
                    checked_at: new Date().toISOString(),
                    verdict: 'fail',
                    deploy_message: data?.message || 'Relay preflight failed.',
                    summary: { ok_count: 0, warning_count: 0, error_count: 1 },
                    environment: [{
                        name: 'Preflight API',
                        status: 'error',
                        checks: [{ status: 'error', title: 'Preflight API failed', detail: data?.message || 'Unknown error' }]
                    }],
                    subnets: [],
                    relay_servers: [],
                    computing_nodes: []
                });
            }
            if (!this.preflightForceable) {
                this.allowKnownBlockerOverride = false;
            }
        } catch (e) {
            this.setPreflightReport({
                ok: false,
                checked_at: new Date().toISOString(),
                verdict: 'fail',
                deploy_message: 'Relay preflight request failed.',
                summary: { ok_count: 0, warning_count: 0, error_count: 1 },
                environment: [{
                    name: 'Preflight API',
                    status: 'error',
                    checks: [{ status: 'error', title: 'Preflight request failed', detail: String(e) }]
                }],
                subnets: [],
                relay_servers: [],
                computing_nodes: []
            });
            this.allowKnownBlockerOverride = false;
        } finally {
            this.preflightLoading = false;
            await this.service.render();
        }
    }

    public get preflightReady(): boolean {
        return this.useDummy || !!this.preflightReport?.ok;
    }

    public get preflightForceable(): boolean {
        return !!this.preflightReport?.force_allowed && !(this.preflightReport?.hard_error_count > 0);
    }

    public get canDeployAll(): boolean {
        return !!this.step5ImageId && !this.preflightLoading && (
            this.useDummy ||
            this.preflightReady ||
            (this.allowKnownBlockerOverride && this.preflightForceable)
        );
    }

    public getPreflightSections(): any[] {
        if (!this.preflightReport) return [];
        return [
            { key: 'environment', title: 'Environment', items: this.preflightReport.environment || [] },
            { key: 'subnets', title: 'Subnets', items: this.preflightReport.subnets || [] },
            { key: 'relay_servers', title: 'Relay Servers', items: this.preflightReport.relay_servers || [] },
            { key: 'computing_nodes', title: 'Computing Nodes', items: this.preflightReport.computing_nodes || [] },
        ]
            .filter(section => section.items.length > 0)
            .map(section => ({
                ...section,
                warningCount: this.countPreflightSectionChecks(section.items, 'warning'),
                errorCount: this.countPreflightSectionChecks(section.items, 'error'),
            }));
    }

    private countPreflightSectionChecks(items: any[], status: string): number {
        return (items || []).reduce((count: number, item: any) => {
            const checks = item?.checks || [];
            if (checks.length === 0) {
                return count + (item?.status === status ? 1 : 0);
            }
            return count + checks.filter((check: any) => check?.status === status).length;
        }, 0);
    }

    public isPreflightSectionCollapsed(key: string): boolean {
        return !!this.preflightSectionCollapsed[key];
    }

    public async togglePreflightSection(key: string) {
        this.preflightSectionCollapsed[key] = !this.preflightSectionCollapsed[key];
        await this.service.render();
    }

    public getPreflightSectionFrameClass(section: any): string {
        if (section?.errorCount > 0) return 'border-red-200 bg-red-50/30';
        if (section?.warningCount > 0) return 'border-amber-200 bg-amber-50/30';
        return 'border-zinc-200 bg-white';
    }

    public getPreflightSectionHeaderClass(section: any): string {
        if (section?.errorCount > 0) return 'bg-red-50 border-red-200 text-red-800';
        if (section?.warningCount > 0) return 'bg-amber-50 border-amber-200 text-amber-800';
        return 'bg-zinc-50 border-zinc-200 text-zinc-700';
    }

    public getStatusBadgeClass(status: string): string {
        switch (status) {
            case 'ok':
            case 'ready':
            case 'relay-ready':
            case 'completed':
            case 'deployed':
                return 'bg-green-100 text-green-700';
            case 'warning':
            case 'pending':
            case 'paused':
                return 'bg-amber-100 text-amber-700';
            case 'in_progress':
            case 'deploying':
            case 'running':
                return 'bg-blue-100 text-blue-700';
            case 'failed':
            case 'error':
                return 'bg-red-100 text-red-700';
            default:
                return 'bg-zinc-100 text-zinc-600';
        }
    }

    private async syncPersistedOrchestrationJob(): Promise<boolean> {
        if (this.createdRelayId) {
            const { code, data } = await wiz.call("latest_orchestration", { group_id: this.createdRelayId });
            if (code === 200 && data?.job) {
                this.orchestrationJobId = data.job.id || this.orchestrationJobId;
                this.deployStarted = true;
                this.setOrchestrationJob(data.job);
                return true;
            }
        }

        if (this.orchestrationJobId) {
            const { code, data } = await wiz.call("orchestration_status", { job_id: this.orchestrationJobId });
            if (code === 200 && data?.job) {
                this.deployStarted = true;
                this.setOrchestrationJob(data.job);
                return true;
            }
        }

        return false;
    }

    private syncOrchestrationJob(job: any) {
        this.orchestrationJob = job;
        if (!job) return;

        this.deployStarted = true;

        const nextDeploymentStatus: any = {};
        const nextNodeDeployStatus: any = {};

        for (const relayServer of job.relay_servers || []) {
            nextDeploymentStatus[relayServer.node_id] = {
                imageDeployed: relayServer.status !== 'pending',
                ready: !!relayServer.ready,
                osReady: !!relayServer.ready,
                status: relayServer.status,
                readyWaitRemainingSeconds: Number(relayServer.ready_wait_remaining_seconds || 0),
                message: relayServer.message || ''
            };

            const localRelay = this.relayServers.find((item: any) => String(item.id) === String(relayServer.node_id));
            if (localRelay && relayServer.power_state) {
                localRelay.power_status = relayServer.power_state;
            }
        }

        if (Object.keys(nextDeploymentStatus).length > 0) {
            this.deploymentStatus = nextDeploymentStatus;
        }

        for (const computingNode of job.computing_nodes || []) {
            const nextStatus = computingNode.status === 'error' ? 'failed' : computingNode.status;
            nextNodeDeployStatus[computingNode.node_id] = {
                status: nextStatus,
                message: computingNode.message || ''
            };

            const localNode = this.computingNodes.find((item: any) => String(item.id) === String(computingNode.node_id));
            if (localNode && computingNode.power_state) {
                localNode.power_status = computingNode.power_state;
            }
        }

        if (Object.keys(nextNodeDeployStatus).length > 0) {
            this.nodeDeployStatus = nextNodeDeployStatus;
        }

        const computePowerStep = (job.steps || []).find((step: any) => step.key === 'compute-power-off');
        this.poweringOff = computePowerStep?.status === 'in_progress';
        this.poweredOff = ['completed', 'in_progress'].includes(computePowerStep?.status || '');
        this.deployCompleted = job.status === 'completed';
        this.updateDeployStats();
    }

    private startOrchestrationPoll() {
        if (this.deployCheckInterval) clearInterval(this.deployCheckInterval);
        this.deployCheckInterval = setInterval(async () => {
            await this.checkOrchestrationStatus();
        }, 10000);
    }

    private async checkOrchestrationStatus() {
        const syncedJob = await this.syncPersistedOrchestrationJob();
        if (syncedJob && this.orchestrationJob) {
            await this.refreshPowerStatus(false);
            if (['completed', 'failed'].includes(this.orchestrationJob.status)) {
                if (this.deployCheckInterval) {
                    clearInterval(this.deployCheckInterval);
                    this.deployCheckInterval = null;
                }
            }
        }
        await this.service.render();
    }

    public getOrchestrationSteps(): any[] {
        return this.orchestrationJob?.steps || [];
    }

    public orchestrationDisplayStatus(): string {
        const controlState = String(this.orchestrationJob?.control_state || '').toLowerCase();
        if (['paused', 'runner_error', 'stopped'].includes(controlState)) return controlState;
        return this.orchestrationJob?.status || 'pending';
    }

    public canPauseOrchestration(): boolean {
        return ['pending', 'running'].includes(String(this.orchestrationJob?.status || '').toLowerCase())
            && this.orchestrationDisplayStatus() === 'running'
            && !this.orchestrationControlRunning;
    }

    public canResumeOrchestration(): boolean {
        if (!['pending', 'running'].includes(String(this.orchestrationJob?.status || '').toLowerCase())) return false;
        return ['paused', 'runner_error'].includes(this.orchestrationDisplayStatus())
            || this.orchestrationJob?.server_runner_enabled !== true;
    }

    public canStopOrchestration(): boolean {
        return ['pending', 'running'].includes(String(this.orchestrationJob?.status || '').toLowerCase())
            && this.orchestrationDisplayStatus() !== 'stopped'
            && !this.orchestrationControlRunning;
    }

    public orchestrationRunnerLabel(): string {
        if (this.orchestrationJob?.server_runner_enabled !== true) return 'server runner disabled';
        const runnerStatus = String(this.orchestrationJob?.server_runner?.status || 'starting');
        const heartbeat = String(this.orchestrationJob?.server_runner?.heartbeat_at || '');
        return heartbeat ? `server runner ${runnerStatus} · ${heartbeat}` : `server runner ${runnerStatus}`;
    }

    public async pauseOrchestration() {
        if (!this.canPauseOrchestration()) return;
        if (!confirm('Pause this orchestration after the current safe checkpoint? Already queued work may finish.')) return;
        this.orchestrationControlRunning = true;
        await this.service.render();
        const { code, data } = await wiz.call('orchestration_pause', {
            job_id: this.orchestrationJob?.id || this.orchestrationJobId,
            group_id: this.orchestrationJob?.group_id || this.createdRelayId
        });
        this.orchestrationControlRunning = false;
        if (code === 200 && data?.job) this.setOrchestrationJob(data.job);
        else alert(data?.message || 'Failed to pause orchestration.');
        await this.service.render();
    }

    public async resumeOrchestration() {
        if (!this.canResumeOrchestration() || this.orchestrationControlRunning) return;
        if (!confirm('Resume this orchestration on the server?')) return;
        this.orchestrationControlRunning = true;
        await this.service.render();
        const { code, data } = await wiz.call('orchestration_resume', {
            job_id: this.orchestrationJob?.id || this.orchestrationJobId,
            group_id: this.orchestrationJob?.group_id || this.createdRelayId
        });
        this.orchestrationControlRunning = false;
        if (code === 200 && data?.job) {
            this.setOrchestrationJob(data.job);
            this.startOrchestrationPoll();
        } else {
            alert(data?.message || 'Failed to resume orchestration.');
        }
        await this.service.render();
    }

    public async stopOrchestration() {
        if (!this.canStopOrchestration()) return;
        if (!confirm('Stop this orchestration? Pending operations will be cancelled and the active step will fail.')) return;
        this.orchestrationControlRunning = true;
        await this.service.render();
        const { code, data } = await wiz.call('orchestration_stop', {
            job_id: this.orchestrationJob?.id || this.orchestrationJobId,
            group_id: this.orchestrationJob?.group_id || this.createdRelayId
        });
        this.orchestrationControlRunning = false;
        if (data?.job) this.setOrchestrationJob(data.job);
        if (code !== 200) alert(data?.message || 'Failed to stop orchestration.');
        if (code === 200 && this.deployCheckInterval) {
            clearInterval(this.deployCheckInterval);
            this.deployCheckInterval = null;
        }
        await this.service.render();
    }

    public getOrchestrationStages(): any[] {
        return this.orchestrationJob?.stage_catalog || [];
    }

    public isCurrentStage(stage: any): boolean {
        return !!stage && stage.key === this.orchestrationJob?.current_stage;
    }

    public getStepElapsedLabel(step: any): string {
        if (!step || step.key !== 'relay-script' || step.status !== 'completed') {
            return '';
        }

        const startedAt = this.parseStepTimestamp(step.started);
        const completedAt = this.parseStepTimestamp(step.completed);
        if (startedAt === null || completedAt === null || completedAt < startedAt) {
            return '';
        }

        const elapsedSeconds = Math.max(0, Math.round((completedAt - startedAt) / 1000));
        return this.formatElapsedSeconds(elapsedSeconds);
    }

    public canOpenOrchestrationLog(step: any): boolean {
        if (!step || step.key !== 'relay-script') return false;
        return !!step.status && step.status !== 'pending';
    }

    private currentOrchestrationLogStep(): any {
        return (this.orchestrationJob?.steps || []).find((step: any) => step.key === 'relay-script') || null;
    }

    private orchestrationLogShouldOpenSummary(step: any): boolean {
        return step?.status === 'failed' || this.orchestrationJob?.status === 'failed';
    }

    public async openOrchestrationLog(step: any) {
        if (!this.canOpenOrchestrationLog(step)) return;
        this.orchestrationLogVisible = true;
        this.orchestrationLogMeta = { ...(step || {}) };
        this.orchestrationLogTab = this.orchestrationLogShouldOpenSummary(step) ? 'summary' : 'script';
        this.orchestrationIntegratedLogs = [];
        this.orchestrationNodeLogs = [];
        this.orchestrationSelectedNodeLog = null;
        this.orchestrationFailureSummary = null;
        this.orchestrationFailureActionMessage = '';
        this.orchestrationLogTitle = step?.log_label || step?.title || 'Relay script log';
        this.orchestrationLogFilename = step?.log_filename || '';
        this.orchestrationLogMessage = this.orchestrationLogTab === 'summary' ? 'Loading failure summary...' : 'Loading log...';
        if (!this.orchestrationLogContent) this.orchestrationLogContent = '';
        await this.loadOrchestrationLogList(false);
        if (this.orchestrationLogTab === 'summary') {
            await this.loadOrchestrationFailureSummary(false);
        } else {
            await this.refreshOrchestrationLog(false);
        }
        if (this.currentOrchestrationLogStep()?.status === 'in_progress') {
            this.startOrchestrationLogPoll();
        }
        await this.service.render();
    }

    private orchestrationLogContext(): any {
        return {
            jobId: this.orchestrationJob?.id || this.orchestrationJobId || '',
            groupId: this.orchestrationJob?.group_id || this.createdRelayId || ''
        };
    }

    public async loadOrchestrationLogList(shouldRender: boolean = true) {
        const { jobId, groupId } = this.orchestrationLogContext();
        if (!jobId && !groupId) return;
        const { code, data } = await wiz.call("orchestration_logs", {
            job_id: jobId,
            group_id: groupId
        });
        if (code === 200) {
            this.orchestrationIntegratedLogs = data?.integrated_logs || [];
            this.orchestrationNodeLogs = data?.individual_logs || [];
            const selectedFilename = this.orchestrationSelectedNodeLog?.filename || '';
            this.orchestrationSelectedNodeLog = this.orchestrationNodeLogs.find((log: any) => log.filename === selectedFilename) || this.orchestrationNodeLogs[0] || null;
            if (!this.orchestrationLogFilename && data?.script_log_filename) {
                this.orchestrationLogFilename = data.script_log_filename;
            }
        }
        if (shouldRender) await this.service.render();
    }

    public async loadOrchestrationFailureSummary(shouldRender: boolean = true) {
        const { jobId, groupId } = this.orchestrationLogContext();
        if (!jobId && !groupId) return;

        this.orchestrationLogLoading = true;
        const { code, data } = await wiz.call("orchestration_failure_summary", {
            job_id: jobId,
            group_id: groupId
        });
        this.orchestrationLogLoading = false;

        if (code === 200) {
            this.orchestrationFailureSummary = data?.summary || null;
            if (data?.job) this.setOrchestrationJob(data.job);
            this.orchestrationLogMessage = this.orchestrationFailureSummary?.step_message || '';
        } else {
            this.orchestrationFailureSummary = null;
            this.orchestrationLogMessage = data?.message || 'Failed to load failure summary.';
        }
        if (shouldRender) await this.service.render();
    }

    public async selectOrchestrationLogTab(tab: string) {
        this.orchestrationLogTab = tab;
        this.orchestrationLogContent = '';
        this.orchestrationLogMessage = tab === 'summary' ? 'Loading failure summary...' : (tab === 'nodes' ? 'Loading node log...' : 'Loading log...');
        if (tab === 'summary') {
            await this.loadOrchestrationFailureSummary(false);
            await this.service.render();
            return;
        }
        if (tab === 'nodes') {
            await this.loadOrchestrationLogList(false);
        }
        await this.refreshOrchestrationLog(false);
        await this.service.render();
    }

    public async selectOrchestrationNodeLog(log: any) {
        this.orchestrationSelectedNodeLog = log;
        this.orchestrationLogContent = '';
        this.orchestrationLogMessage = 'Loading node log...';
        await this.refreshOrchestrationLog(false);
        await this.service.render();
    }

    public async refreshOrchestrationLog(shouldRender: boolean = true) {
        if (!this.orchestrationLogVisible) return;
        const { jobId, groupId } = this.orchestrationLogContext();
        if (!jobId && !groupId) {
            this.orchestrationLogMessage = 'Relay orchestration job is not available.';
            if (shouldRender) await this.service.render();
            return;
        }

        if (this.orchestrationLogTab === 'summary') {
            await this.loadOrchestrationFailureSummary(shouldRender);
            return;
        }

        this.orchestrationLogLoading = true;
        if (this.orchestrationLogTab === 'nodes') {
            await this.loadOrchestrationLogList(false);
        }
        const filename = this.orchestrationLogTab === 'nodes'
            ? (this.orchestrationSelectedNodeLog?.filename || '')
            : (this.orchestrationLogFilename || this.orchestrationLogMeta?.log_filename || '');
        if (this.orchestrationLogTab === 'nodes' && !filename) {
            this.orchestrationLogLoading = false;
            this.orchestrationLogContent = '';
            this.orchestrationLogMessage = 'No individual node logs found yet.';
            if (shouldRender) await this.service.render();
            return;
        }
        const { code, data } = await wiz.call("orchestration_log_content", {
            job_id: jobId,
            group_id: groupId,
            step_key: 'relay-script',
            filename
        });
        this.orchestrationLogLoading = false;

        if (code === 200) {
            this.orchestrationLogContent = data?.content || '';
            if (this.orchestrationLogTab === 'script') {
                this.orchestrationLogFilename = data?.filename || this.orchestrationLogFilename;
            }
            this.orchestrationLogMessage = data?.message || '';
            const currentStep = this.currentOrchestrationLogStep();
            if (currentStep && data?.step_status) {
                currentStep.status = data.step_status;
                currentStep.message = data.message || currentStep.message;
            }
            if (data?.running) this.startOrchestrationLogPoll();
            else this.stopOrchestrationLogPoll();
        } else {
            this.orchestrationLogMessage = data?.message || 'Failed to load relay script log.';
            const currentStep = this.currentOrchestrationLogStep();
            if (currentStep?.status !== 'in_progress') this.stopOrchestrationLogPoll();
        }

        if (shouldRender) await this.service.render();
    }

    public async runOrchestrationRecoveryCheck() {
        if (this.orchestrationRecoveryRunning) return;
        const { jobId, groupId } = this.orchestrationLogContext();
        if (!jobId && !groupId) return;

        this.orchestrationRecoveryRunning = true;
        this.orchestrationFailureActionMessage = 'Running recovery check...';
        await this.service.render();

        const { code, data } = await wiz.call("orchestration_recovery_check", {
            job_id: jobId,
            group_id: groupId
        });
        this.orchestrationRecoveryRunning = false;
        if (code === 200) {
            this.orchestrationFailureSummary = data?.summary || this.orchestrationFailureSummary;
            if (data?.job) this.setOrchestrationJob(data.job);
            this.orchestrationFailureActionMessage = data?.recovery_result?.message || 'Recovery check completed.';
        } else {
            this.orchestrationFailureActionMessage = data?.message || 'Recovery check failed.';
        }
        await this.service.render();
    }

    public async stopOrchestrationRelayScript() {
        if (this.orchestrationStopRunning) return;
        const { jobId, groupId } = this.orchestrationLogContext();
        if (!jobId && !groupId) return;
        if (!confirm('Stop the running relay script?')) return;

        this.orchestrationStopRunning = true;
        this.orchestrationFailureActionMessage = 'Stopping relay script...';
        await this.service.render();

        const { code, data } = await wiz.call("orchestration_stop", {
            job_id: jobId,
            group_id: groupId
        });
        this.orchestrationStopRunning = false;
        if (code === 200) {
            this.orchestrationFailureSummary = data?.summary || this.orchestrationFailureSummary;
            if (data?.job) this.setOrchestrationJob(data.job);
            this.orchestrationFailureActionMessage = data?.message || 'Relay script stopped.';
            this.stopOrchestrationLogPoll();
            await this.loadOrchestrationFailureSummary(false);
        } else {
            this.orchestrationFailureActionMessage = data?.message || 'Relay script stop failed.';
        }
        await this.service.render();
    }

    public async rerunOrchestrationFromLog() {
        if (this.orchestrationRerunRunning) return;
        const { jobId, groupId } = this.orchestrationLogContext();
        if (!jobId && !groupId) return;
        if (!confirm('Rerun this failed relay orchestration job?')) return;

        this.orchestrationRerunRunning = true;
        this.orchestrationFailureActionMessage = 'Starting rerun...';
        await this.service.render();

        const { code, data } = await wiz.call("orchestration_rerun", {
            job_id: jobId,
            group_id: groupId
        });
        this.orchestrationRerunRunning = false;
        if (code === 200 && data?.job) {
            this.orchestrationJobId = data.job.id;
            this.setOrchestrationJob(data.job);
            this.orchestrationFailureActionMessage = 'Rerun started.';
            this.orchestrationFailureSummary = null;
            this.orchestrationLogTab = 'script';
            this.orchestrationLogContent = '';
            this.orchestrationLogFilename = data.job?.steps?.find((step: any) => step.key === 'relay-script')?.log_filename || '';
            await this.loadOrchestrationLogList(false);
            await this.refreshOrchestrationLog(false);
            if (this.orchestrationJob && !['completed', 'failed'].includes(this.orchestrationJob.status)) {
                this.startOrchestrationPoll();
                this.startOrchestrationLogPoll();
            }
        } else {
            if (data?.report) this.setPreflightReport(data.report);
            this.orchestrationFailureActionMessage = data?.message || 'Rerun failed to start.';
        }
        await this.service.render();
    }

    private startOrchestrationLogPoll() {
        if (this.orchestrationLogInterval) return;
        this.orchestrationLogInterval = setInterval(async () => {
            await this.refreshOrchestrationLog();
        }, 3000);
    }

    private stopOrchestrationLogPoll() {
        if (!this.orchestrationLogInterval) return;
        clearInterval(this.orchestrationLogInterval);
        this.orchestrationLogInterval = null;
    }

    public async closeOrchestrationLog() {
        this.stopOrchestrationLogPoll();
        this.orchestrationLogVisible = false;
        this.orchestrationLogLoading = false;
        this.orchestrationLogTitle = '';
        this.orchestrationLogFilename = '';
        this.orchestrationLogContent = '';
        this.orchestrationLogMessage = '';
        this.orchestrationLogMeta = null;
        this.orchestrationLogTab = 'script';
        this.orchestrationIntegratedLogs = [];
        this.orchestrationNodeLogs = [];
        this.orchestrationSelectedNodeLog = null;
        this.orchestrationFailureSummary = null;
        this.orchestrationFailureActionMessage = '';
        this.orchestrationRecoveryRunning = false;
        this.orchestrationRerunRunning = false;
        this.orchestrationStopRunning = false;
        await this.service.render();
    }

    private parseStepTimestamp(value: any): number | null {
        const raw = String(value || '').trim();
        if (!raw) {
            return null;
        }

        const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
        const timestamp = Date.parse(normalized);
        if (Number.isNaN(timestamp)) {
            return null;
        }

        return timestamp;
    }

    private formatElapsedSeconds(totalSeconds: number): string {
        const safeSeconds = Math.max(0, Math.floor(totalSeconds));
        const hours = Math.floor(safeSeconds / 3600);
        const minutes = Math.floor((safeSeconds % 3600) / 60);
        const seconds = safeSeconds % 60;

        if (hours > 0) {
            return `${hours}h ${minutes}m ${seconds}s`;
        }

        if (minutes > 0) {
            return `${minutes}m ${seconds}s`;
        }

        return `${seconds}s`;
    }

    // Step 5: Create & Deploy
    public async submitCreate() {
        if (!this.relayName.trim()) return;
        this.creating = true;
        await this.service.render();
        this.creating = false;
        const groupId = await this.ensureRelayGroupSaved(true);
        if (groupId) {
            if (this.useDummy) {
                this.showWizard = false;
                alert('Dummy mode: Relay group created (no actual deployment)');
                await this.load();
            }
        }
        await this.service.render();
    }

    // Step 5: Deploy All Computing Nodes via PXE
    public async deployAllComputing() {
        if (!this.step5ImageId) {
            alert('Please select an OS image first.');
            return;
        }
        if (!this.preflightReady) {
            await this.runPreflight();
            if (!this.preflightReady) {
                if (!this.preflightForceable) {
                    alert('Preflight failed. Resolve the reported errors before deployment.');
                    return;
                }
                if (!this.allowKnownBlockerOverride) {
                    alert(this.preflightReport?.force_message || 'Known relay blocker selected. Enable override to continue.');
                    return;
                }
            }
        }
        const overrideRequested = !this.preflightReady && this.preflightForceable && this.allowKnownBlockerOverride;
        const confirmMessage = overrideRequested
            ? 'Known relay blocker override is enabled for this run. Relay servers are prepared first, then computing nodes are deployed in bounded parallel fan-out. Continue?'
            : 'Relay servers are prepared first, then computing nodes are deployed in bounded parallel fan-out. Continue?';
        if (!confirm(confirmMessage)) return;

        const groupId = await this.ensureRelayGroupSaved(false);
        if (!groupId) return;

        this.deployStarted = true;
        this.deployCompleted = false;
        await this.service.render();

        const orchestrationPayload = {
            group_id: groupId,
            group: this.buildRelayPayload(),
            relay_servers: this.relayServers,
            computing_nodes: this.computingNodes,
            assignments: this.assignments,
            relay_image_id: this.selectedImageId,
            computing_image_id: this.step5ImageId,
            compute_window_settings: this.normalizedComputeWindowSettings(),
            use_dummy: this.useDummy,
            force: overrideRequested,
        };
        const { code, data } = await wiz.call("orchestration_start", {
            data: JSON.stringify(orchestrationPayload)
        });
        if (code === 200 && data?.job) {
            this.orchestrationJobId = data.job.id;
            this.setOrchestrationJob(data.job);
            if (['completed', 'failed'].includes(data.job.status)) {
                this.deployCompleted = data.job.status === 'completed';
            } else {
                this.startOrchestrationPoll();
            }
        } else {
            this.deployStarted = false;
            if (data?.report) this.setPreflightReport(data.report);
            alert(data?.message || 'Deployment failed to start');
        }
        await this.service.render();
    }

    public updateDeployStats() {
        const stats = { total: 0, deployed: 0, in_progress: 0, failed: 0 };
        for (const nodeId of Object.keys(this.nodeDeployStatus)) {
            stats.total++;
            const s = this.nodeDeployStatus[nodeId].status;
            if (s === 'deployed') stats.deployed++;
            else if (s === 'deploying') stats.in_progress++;
            else if (s === 'failed') stats.failed++;
        }
        this.deployStats = stats;
    }

    private startDeployStatusCheck() {
        if (this.deployCheckInterval) clearInterval(this.deployCheckInterval);
        this.deployCheckInterval = setInterval(async () => {
            await this.checkDeployNodeStatus();
        }, 15000);
    }

    private async checkDeployNodeStatus() {
        // Get node IDs that are still deploying
        const deployingIds = Object.keys(this.nodeDeployStatus)
            .filter(nid => this.nodeDeployStatus[nid].status === 'deploying');
        if (deployingIds.length === 0) {
            this.deployCompleted = true;
            if (this.deployCheckInterval) {
                clearInterval(this.deployCheckInterval);
                this.deployCheckInterval = null;
            }
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call("deploy_node_status", {
            data: JSON.stringify({ node_ids: deployingIds.map(id => parseInt(id)) })
        });
        if (code === 200 && data.results) {
            for (const nid of Object.keys(data.results)) {
                const r = data.results[nid];
                if (r.ready) {
                    this.nodeDeployStatus[nid] = { status: 'deployed' };
                    // Update power status
                    const cn = this.computingNodes.find((n: any) => String(n.id) === nid);
                    if (cn) cn.power_status = 'on';
                }
            }
            this.updateDeployStats();
            // Check if all done
            const stillDeploying = Object.keys(this.nodeDeployStatus)
                .filter(nid => this.nodeDeployStatus[nid].status === 'deploying');
            if (stillDeploying.length === 0) {
                this.deployCompleted = true;
                if (this.deployCheckInterval) {
                    clearInterval(this.deployCheckInterval);
                    this.deployCheckInterval = null;
                }
            }
        }
        await this.service.render();
    }

    // Power On All (after deployment completes)
    public async powerOnAllNodes() {
        this.poweringOn = true;
        await this.service.render();
        const allNodeIds = this.computingNodes.map((n: any) => n.id);
        await wiz.call("power_on_all", { data: JSON.stringify({ node_ids: allNodeIds }) });
        this.poweringOn = false;
        this.computingNodes.forEach((cn: any) => { cn.power_status = 'on'; });
        await this.service.render();
    }

    // Power Off All
    public async powerOffAllNodes() {
        this.poweringOff = true;
        await this.service.render();
        const allNodeIds = this.computingNodes.map((n: any) => n.id);
        await wiz.call("power_off_all", { data: JSON.stringify({ node_ids: allNodeIds }) });
        this.poweringOff = false;
        this.computingNodes.forEach((cn: any) => { cn.power_status = 'off'; });
        await this.service.render();
    }

    // Power On/Off per server
    public async powerOnServerNodes(serverId: any) {
        const nodes = this.getNodesForServer(serverId);
        const nodeIds = nodes.map((n: any) => n.id);
        await wiz.call("power_on_all", { data: JSON.stringify({ node_ids: nodeIds }) });
        nodes.forEach((n: any) => { n.power_status = 'on'; });
        await this.service.render();
    }

    public async powerOffServerNodes(serverId: any) {
        const nodes = this.getNodesForServer(serverId);
        const nodeIds = nodes.map((n: any) => n.id);
        await wiz.call("power_off_all", { data: JSON.stringify({ node_ids: nodeIds }) });
        nodes.forEach((n: any) => { n.power_status = 'off'; });
        await this.service.render();
    }

    // Power single node
    public async powerNode(nodeId: number, action: string) {
        await wiz.call("power_node", { node_id: nodeId, action });
        const node = this.computingNodes.find((n: any) => n.id === nodeId);
        if (node) node.power_status = action;
        await this.service.render();
    }

    // Deploy single computing node
    public async deploySingleNode(nodeId: number) {
        if (!this.step5ImageId) {
            alert('Please select an OS image first.');
            return;
        }
        this.nodeDeployStatus[nodeId] = { status: 'deploying' };
        this.updateDeployStats();
        await this.service.render();

        const { code, data } = await wiz.call("deploy_server", { node_id: nodeId, image_id: this.step5ImageId });
        if (code === 200) {
            this.nodeDeployStatus[nodeId] = { status: 'deploying', message: 'PXE deploy initiated' };
            // Ensure polling is running
            if (!this.deployCheckInterval) this.startDeployStatusCheck();
        } else {
            this.nodeDeployStatus[nodeId] = { status: 'failed', message: data?.message || 'Deploy failed' };
        }
        this.updateDeployStats();
        await this.service.render();
    }

    public async finishWizard() {
        if (this.deployCheckInterval) {
            clearInterval(this.deployCheckInterval);
            this.deployCheckInterval = null;
        }
        this.createdRelayId = '';
        this.setPreflightReport(null);
        this.setOrchestrationJob(null);
        this.orchestrationJobId = '';
        this.showWizard = false;
        await this.load();
        await this.service.render();
    }

    private isEnglishLanguage() {
        return String(this.translate.currentLang || this.translate.getDefaultLang() || 'ko').toLowerCase().startsWith('en');
    }

    private setPreflightReport(report: any) {
        this.preflightReportRaw = report ? JSON.parse(JSON.stringify(report)) : null;
        this.preflightReport = this.localizeRelayValue(this.preflightReportRaw);
        this.preflightSectionCollapsed = {};
        if (this.preflightReport) {
            for (const section of this.getPreflightSections()) {
                this.preflightSectionCollapsed[section.key] = true;
            }
        }
    }

    private setOrchestrationJob(job: any) {
        this.orchestrationJobRaw = job ? JSON.parse(JSON.stringify(job)) : null;
        this.syncOrchestrationJob(this.localizeRelayValue(this.orchestrationJobRaw));
    }

    private reapplyRelayLocalization() {
        this.preflightReport = this.localizeRelayValue(this.preflightReportRaw ? JSON.parse(JSON.stringify(this.preflightReportRaw)) : null);
        this.syncOrchestrationJob(this.localizeRelayValue(this.orchestrationJobRaw ? JSON.parse(JSON.stringify(this.orchestrationJobRaw)) : null));
    }

    private localizeRelayText(value: string) {
        if (!this.isEnglishLanguage()) return value;

        const replacements: Array<[string, string]> = [
            ['2026-04-15 기준으로 relay path가 재검증된 후보입니다.', 'Candidate revalidated for the relay path as of 2026-04-15.'],
            ['2026-04-15 BMC evidence에서 relay ready 이전 전원 off blocker가 재현되었습니다.', '2026-04-15 BMC evidence reproduced the power-off blocker before relay ready.'],
            ['Relay image deploy와 ready gate를 통과하기 전 단계입니다.', 'Stage before relay image deploy and ready gate completion.'],
            ['Relay sync, computing PXE materialization, child boot handoff를 준비하는 단계입니다.', 'Stage that prepares relay sync, computing PXE materialization, and child boot handoff.'],
            ['Computing child deploy와 callback/ready verify를 진행하는 단계입니다.', 'Stage that runs computing child deploy and callback/ready verification.'],
            ['next-server 또는 boot filename이 비어 있습니다.', 'next-server or boot filename is empty.'],
            ['TFTP 응답이 너무 짧습니다.', 'TFTP response is too short.'],
            ['stale relay assignment 감지', 'Stale relay assignment detected'],
            ['relay assignment DB 정합성 확인', 'Relay assignment DB consistency verified'],
            ['relay DHCP per-node map 생성 불가', 'Unable to generate relay DHCP per-node map'],
            ['MAC 누락 node=', 'missing MAC node='],
            ['mixed firmware node boot filename map 확인', 'Verified mixed firmware node boot filename map'],
            ['node별 boot filename map 확인', 'Verified per-node boot filename map'],
            ['서브넷 내 노드 없음', 'No nodes in subnet'],
            ['노드 NIC VLAN policy 검증 필요', 'Node NIC VLAN policy requires verification'],
            ['누락 후보', 'missing candidates'],
            ['노드 NIC VLAN policy 확인', 'Verified node NIC VLAN policy'],
            ['OPA/IPoIB node NIC 검증 필요', 'OPA/IPoIB node NIC requires verification'],
            ['InfiniBand interface 누락 후보', 'InfiniBand interface missing candidates'],
            ['OPA/IPoIB node NIC 확인', 'Verified OPA/IPoIB node NIC'],
            ['bounded parallel fan-out 적용', 'Bounded parallel fan-out applied'],
            ['relayresource 사용 가능', 'relayresource available'],
            ['relayresource 경로를 찾지 못했습니다.', 'relayresource path not found.'],
            ['ipmitool 사용 가능', 'ipmitool available'],
            ['BMC preflight와 전원 제어를 수행할 수 있습니다.', 'BMC preflight and power control are available.'],
            ['ipmitool을 찾지 못했습니다.', 'ipmitool not found.'],
            ['BMC 전원 제어와 상태 조회를 수행할 수 없습니다.', 'BMC power control and status checks are unavailable.'],
            ['TFTP root 확인', 'Verified TFTP root'],
            ['TFTP root를 찾지 못했습니다.', 'TFTP root not found.'],
        ];

        let text = String(value ?? '');
        for (const [source, target] of replacements) {
            text = text.split(source).join(target);
        }
        return text;
    }

    private localizeRelayValue(value: any): any {
        if (typeof value === 'string') return this.localizeRelayText(value);
        if (Array.isArray(value)) return value.map((item) => this.localizeRelayValue(item));
        if (value && typeof value === 'object') {
            return Object.keys(value).reduce((result: any, key: string) => {
                result[key] = this.localizeRelayValue(value[key]);
                return result;
            }, {});
        }
        return value;
    }

    // Get nodes assigned to a particular relay server
    public getNodesForServer(serverId: any): any[] {
        const nodeIds = this.assignments[serverId] || [];
        return this.computingNodes.filter((n: any) => nodeIds.includes(n.id) || nodeIds.includes(String(n.id)));
    }

    // Step validation
    public get wizardStepLabels(): string[] {
        if (this.wizardMode === 'template') {
            return [
                '시작 방법 선택',
                '템플릿 업로드/검증',
                '릴레이 서버 매핑',
                '서브넷 / DHCP / Next-server',
                '이미지 / 배포 계획',
                '적용 / 배포',
            ];
        }
        return [
            '시작 방법 선택',
            '노드 선택',
            '릴레이 서버',
            '릴레이 배포',
            '노드 할당',
            '계산 노드 배포',
        ];
    }

    public get canStartSelectedWizard(): boolean {
        if (this.wizardMode === 'manual') return true;
        if (this.wizardMode === 'template') return !!(this.templateSelectedFile || this.templatePreview);
        return false;
    }

    public get templateSummary(): any {
        return this.templatePreview?.summary || {};
    }

    public get templateCluster(): any {
        return this.templatePreview?.cluster || {};
    }

    public get templateClusters(): any[] {
        return this.templatePreview?.clusters || [];
    }

    public get selectedTemplateCluster(): any {
        return this.templateClusters.find((item: any) => item.key === this.selectedTemplateClusterKey) || this.templateClusters[0] || null;
    }

    public get templateValidationDetails(): any[] {
        return this.templatePreview?.validation?.details || [];
    }

    public get templateValidationCards(): any[] {
        const validation = this.templatePreview?.validation || {};
        const total = Number(this.templateSummary?.total_nodes || 0);
        const pct = (value: any) => {
            if (!total) return '';
            return `(${((Number(value || 0) / total) * 100).toFixed(1)}%)`;
        };
        return [
            { key: 'normal', label: '정상', value: validation.normal || 0, sub: pct(validation.normal), icon: 'bx-check-circle', tone: 'green' },
            { key: 'warnings', label: '경고', value: validation.warnings || 0, sub: pct(validation.warnings), icon: 'bx-error', tone: 'amber' },
            { key: 'errors', label: '오류', value: validation.errors || 0, sub: pct(validation.errors), icon: 'bx-error-circle', tone: 'red' },
            { key: 'db_matched', label: 'DB 매칭됨', value: validation.db_matched || 0, sub: pct(validation.db_matched), icon: 'bx-data', tone: 'indigo' },
            { key: 'db_unmatched', label: 'DB 미매칭', value: validation.db_unmatched || 0, sub: pct(validation.db_unmatched), icon: 'bx-data', tone: 'indigo' },
            { key: 'duplicate_mac', label: '중복 MAC', value: validation.duplicate_mac || 0, sub: '', icon: 'bx-target-lock', tone: 'indigo' },
            { key: 'duplicate_ip', label: '중복 IP', value: validation.duplicate_ip || 0, sub: '', icon: 'bx-network-chart', tone: 'indigo' },
            { key: 'missing_vlan', label: '서브넷 누락', value: validation.missing_vlan || 0, sub: '', icon: 'bx-wifi', tone: 'indigo' },
            { key: 'required_missing', label: '필수 컬럼 누락', value: validation.required_missing || 0, sub: '', icon: 'bx-list-check', tone: 'indigo' },
        ];
    }

    public templateValidationIconClass(card: any): string {
        const tone = card?.tone || 'indigo';
        const map: any = {
            green: 'text-emerald-600',
            amber: 'text-amber-500',
            red: 'text-red-500',
            indigo: 'text-indigo-600',
        };
        return map[tone] || map.indigo;
    }

    public templateActionCardClass(action: string): string {
        const selected = this.selectedTemplateClusterAction === action;
        const disabled = this.isTemplateActionDisabled(action);
        if (disabled) return 'border-zinc-200 bg-zinc-50 opacity-70 cursor-not-allowed';
        if (selected) return 'border-indigo-300 ring-1 ring-indigo-200 bg-white';
        return 'border-zinc-200 bg-white hover:border-indigo-200 cursor-pointer';
    }

    public isTemplateActionDisabled(action: string): boolean {
        if (action === 'create') return !this.templateCluster?.can_create;
        if (action === 'update') return !this.templateCluster?.can_update;
        return false;
    }

    public get canGoTemplateStep2(): boolean {
        if (!this.templatePreview) return false;
        const validation = this.templatePreview?.validation || {};
        const hasMatchedNodes = (this.templatePreview?.matched_nodes || []).length > 0;
        const hasRelayMappingCandidates = (this.templatePreview?.relay_mappings || []).length > 0
            && (this.templatePreview?.relay_candidates || []).length > 0;
        return Number(validation.required_missing || 0) === 0
            && Number(validation.duplicate_mac || 0) === 0
            && Number(validation.duplicate_ip || 0) === 0
            && (hasMatchedNodes || hasRelayMappingCandidates);
    }

    public get canGoStep2() { return this.selectedGroupIds.size > 0 || this.selectedNodeIds.size > 0; }
    public get hasValidDhcpAuthorityGroups() {
        const authorityKeys = new Set<string>();
        const authoritySubnetKeys = new Set<string>();
        let authorityCount = 0;
        for (const node of this.selectedRelayCandidates()) {
            const groupKey = this.getDhcpGroupKey(node);
            if (this.isDhcpServer(node)) {
                const subnetKey = String(this.getDhcpSubnetKey(node) || '').trim().toLowerCase();
                if (!groupKey || authorityKeys.has(groupKey) || !subnetKey || authoritySubnetKeys.has(subnetKey)) return false;
                authorityKeys.add(groupKey);
                authoritySubnetKeys.add(subnetKey);
                authorityCount += 1;
            }
        }
        if (authorityCount === 0) return false;
        return this.selectedRelayCandidates().every((node: any) =>
            this.isDhcpServer(node) || authorityKeys.has(this.getDhcpGroupKey(node))
        );
    }
    public get canGoStep3() {
        if (this.wizardMode === 'template' && this.templateRelayMappings.length > 0 && !this.templateRelayMappingsComplete) {
            return false;
        }
        return this.selectedServerIds.size > 0 && this.hasValidDhcpAuthorityGroups;
    }
    public get canGoStep4() { return this.relayServers.length > 0; }
    public get canGoStep5() {
        if (this.useDummy) return true;
        const hasAssignments = Object.values(this.assignments).some((nodes: any) => nodes.length > 0);
        return hasAssignments;
    }

    public getRelayEnvGroupKeys(groupName: string): string[] {
        return [];
    }
}

export default PageKieraRelayComponent;
